import React, { Component } from "react";
import {
  Grid,
  Box,
  Button,
  TableContainer,
  FormControl,
  Menu,
  Paper,
  MenuItem,
  Slide,
  Tooltip,
  Collapse,
  List,
  IconButton,
} from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import {
  Edit,
  Delete,
  RefreshOutlined,
  CallMissedOutgoing,
  Close,
  MoreHoriz,
  Info,
  Save,
  Print,
  Add,
  ViewList,
  AddBox,
  InsertDriveFile,
  ArrowBackIos,
  ArrowForwardIos,
} from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import {
  fetchSales,
  fetchItemMaster,
  fetchDetailMaster,
  fetchCustomerMaster,
  apiURL,
  fetchReferenceMaster,
} from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import { withRouter } from "../HOC/withRouter";
import SalesItemEntry from "./SalesItemEntry";
import SalesInvoiceSelection from "./SalesInvoiceSelection";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import {
  get_YMD_from_SYS,
  isValidItem,
  applyTrimOnObjectValues,
  getRoundOff,
  getString_or_Blank4Null,
  validatedate_min_max,
  copyRowsAllCols,
  getRowData,
  isNumeric,
  getTaxNumFromStr,
  getRowColSum,
  setKeyboardShortcuts,
  getRowOfRT,
  csvFileName,
  isCompanyChange,
} from "../SystemUtility/SystemUtility";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CustomerMaster from "./CustomerMaster";
import ReferenceMaster from "./ReferenceMaster";
import DetailMaster from "./DetailMaster";
import PaymentModeTable from "./PaymentModeTable";
import OrderSelection from "./OrderSelection";
import SalesEWayBill from "./SalesEWayBill";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import moment from "moment";
import ReceiptEntry from "./ReceiptEntry";
import PaymentModeIcon from "../images/Payment Mode icon.jpg";
import SalesE_WayBill from "./SalesE_WayBill";
import CtART from "./CustomTool/ResponsiveTable";
import New_Blue from "../images/New_Icon_page_Blue.png";

class SalesEntry extends Component {
  state = {
    Company: [],
    BillType: [{ name: "Tax" }, { name: "Retail" }],
    Customer: [],
    CompanyList: [],
    ShipTo: [],
    ItemNameList: [],
    StoreList: [],
    PackingList: [],
    TaxNameList: [],
    BillNoList: [],
    LedgerNameList: [],
    ReferenceList: [],
    DetailList: [],
    SalesInvoiceGeneration: "",
    SalesInvoiceDefaultPrint: "",
    SalesInvoiceDefault_Print: "",
    IntSignature_StampPrint: 0,
    CustomerStateCode: "",
    CustomerData: [],
    EWayBillData: [],
    StateList: [],
    ispaid: false,
    isEditMode: false, // Tracks edit mode
    isInitialLoad: true, // Tracks first load
    hasOpenedTransactionType: false,
    expanded: true,
    columns: [
      {
        accessorKey: "bint_salessrno",
        header: "sales S.N.",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "bint_itemsrno",
        header: "S.N.",
        size: 10,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_storename",
        header: "Store Name",
        size: 60,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_itemname",
        header: "Item Name",
        size: 60,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_hsncode",
        header: "HSN",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_unit",
        header: "Packing",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_qty",
        header: "Qty",
        size: 20,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_rate",
        header: "Rate",
        size: 20,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_basicamt",
        header: "Basic Amt",
        size: 50,

        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_disper",
        header: "Dis (%)",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_disamt",
        header: "Dis Amt",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_taxable",
        header: "Taxable",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_taxname",
        header: "Tax",
        size: 20,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_cgstamt",
        header: "CGST",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_sgstamt",
        header: "SGST",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_igstamt",
        header: "IGST",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_totalamt",
        header: "Total Amt",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_remark",
        header: "Remark",
        Cell: ({ cell }) => (
          <div dangerouslySetInnerHTML={{ __html: cell.getValue() }} />
        ),
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
    ],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "SalesEntry:",
        actionType: "AlertResponsive",
        visiblecondition: [
          { colID: "DisableEdit", value: false, relationalOperator: "==" },
        ],
        // hide: (this.props.userPrivilege.Sales == 'R' || this.props.userPrivilege.Sales == 'W')
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "SalesEntry:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Sales == "R" ||
          this.props.userPrivilege.Sales == "W",
      },
    ],
    keyColumn: [
      "bint_itemsrno", //0
      "vac_itemname", //1
      "vac_hsncode", //2
      "vac_unit", //3
      "dec_qty", //4
      "dec_rate", //5
      "dec_basicamt", //6
      "dec_disper", //7
      "dec_disamt", //8
      "dec_taxable", //9
      "vac_taxname", //10
      "dec_cgstamt", //11
      "dec_sgstamt", //12
      "dec_igstamt", //13
      "dec_totalamt", //14
      "vac_remark", //15
      "vac_storename", //16
    ],

    PaymentmodeListCols: [
      "bint_acid",
      "bint_ledgercode",
      "bint_ledgeridsrno",
      "dec_opbalance",
      "vac_backgroundprocess",
      "vac_company",
      "vac_firmname",
      "vac_groupheader",
      "vac_groupname",
      "vac_gstno",
      "vac_ledgername",
    ],

    ValidUnit: [
      { FullName: "BAGS", shortName: "BAG" },
      { FullName: "BALE", shortName: "BAL" },
      { FullName: "BUNDLES", shortName: "BDL" },
      { FullName: "BUCKLES", shortName: "BKL" },
      { FullName: "BILLION OF UNITS", shortName: "BOU" },
      { FullName: "BOX", shortName: "BOX" },
      { FullName: "BOTTLES", shortName: "BTL" },
      { FullName: "BUNCHES", shortName: "BUN" },
      { FullName: "CANS", shortName: "CAN" },
      { FullName: "CUBIC METERS", shortName: "CBM" },
      { FullName: "CUBIC CENTIMETERS", shortName: "CCM" },
      { FullName: "CENTIMETERS", shortName: "CMS" },
      { FullName: "CARTONS", shortName: "CTN" },
      { FullName: "DOZENS", shortName: "DOZ" },
      { FullName: "DRUMS", shortName: "DRM" },
      { FullName: "GREAT GROSS", shortName: "GGK" },
      { FullName: "GRAMMES", shortName: "GMS" },
      { FullName: "GROSS", shortName: "GRS" },
      { FullName: "GROSS YARDS", shortName: "GYD" },
      { FullName: "KILOGRAMS", shortName: "KGS" },
      { FullName: "KILOLITRE", shortName: "KLR" },
      { FullName: "KILOMETRE", shortName: "KME" },
      { FullName: "LITRES", shortName: "LTR" },
      { FullName: "MILILITRE", shortName: "MLT" },
      { FullName: "METERS", shortName: "MTR" },
      { FullName: "METRIC TON", shortName: "MTS" },
      { FullName: "NUMBERS", shortName: "NOS" },
      { FullName: "OTHERS", shortName: "OTH" },
      { FullName: "PACKS", shortName: "PAC" },
      { FullName: "PIECES", shortName: "PCS" },
      { FullName: "PAIRS", shortName: "PRS" },
      { FullName: "QUINTAL", shortName: "QTL" },
      { FullName: "ROLLS", shortName: "ROL" },
      { FullName: "SETS", shortName: "SET" },
      { FullName: "SQUARE FEET", shortName: "SQF" },
      { FullName: "SQUARE METERS", shortName: "SQM" },
      { FullName: "SQUARE YARDS", shortName: "SQY" },
      { FullName: "TABLETS", shortName: "TBS" },
      { FullName: "TEN GROSS", shortName: "TGM" },
      { FullName: "THOUSANDS", shortName: "THD" },
      { FullName: "TONNES", shortName: "TON" },
      { FullName: "TUBES", shortName: "TUB" },
      { FullName: "US GALLONS", shortName: "UGS" },
      { FullName: "UNITS", shortName: "UNT" },
      { FullName: "YARDS", shortName: "YDS" },
    ],
    // transactionType: "Remain",

    formData: {
      edit_salessrno: "",
      dtpDate: get_YMD_from_SYS(new Date()),
      dtpDueDate: "",
      subSupplyType: "",
      cmbCompany: localStorage.getItem("CompanyName"),
      cmbBillType: "",
      txtBillNo: "",
      LblBillNo: "",
      cmbCustomer: "",
      cmbShipTo: "",
      txtOtherDetail: "",
      txtbasicamt: 0,
      txtDiscount: 0,
      txtTaxable: 0,
      txtCGST: "",
      txtSGST: "",
      txtIGST: "",
      txtGrandTotal: "",
      txtTDSAmount: "",
      txtAdvPayment: "",
      txtNetPayment: "",
      txtRoundOff: "",
      cmbTransactionType: "Remain",
      txtRemark: "",
      chkReceiptGenerated: false,
      cmbReference: "",
      dec_remainamt: "",
      txtACKno: "",
      txtACKDate: "",
      txtIRN: "",
      tblCGST: 0,
      tblSGST: 0,
      tblIGST: 0,
      dtpFromDate: "",
      dtpToDate: "",
    },
    autoResetFormData: false,
    searchData: {
      bint_itemsrno: "",
      vac_storename: "",
      vac_itemname: "",
      vac_hsncode: "",
      vac_unit: "",
      dec_qty: "",
      dec_rate: "",
      dec_basicamt: "",
      dec_disper: "",
      dec_disamt: "",
      dec_taxable: "",
      vac_taxname: "",
      dec_cgstamt: "",
      dec_sgstamt: "",
      dec_igstamt: "",
      dec_totalamt: "",
      vac_remark: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    dataLoadStatus: true,
    ARD: null,
    DRP: "",
    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,
    totalBeforeTaxAmt: 0,
    totalAfterTaxAmt: 0,
    totalafterDeductionTaxamt: 0,
    totalAfteraddTaxamt: 0,
    totalBeforeaddTaxamt: 0,
    totalBeforeDeductionTaxamt: 0,

    columnsOtherDetail: [
      { id: "Action", label: "" },
      {
        id: "vac_headingvalue",
        label: "Headings",
        CtrlProps: { focus: false },
      },
      { id: "txtFormate", label: "", CtrlProps: { focus: false } },
      {
        id: "vac_value",
        label: "Values",
        // type: "CtTxt",
        CtrlProps: {
          value: "",
          focus: true,
          width: 250,
          maxLength: 100,
          amountOnlyCondition: [
            {
              colID: "vac_calculation",
              value: "-",
              relationalOperator: "===",
              logicalOperator: "||",
            },
            {
              colID: "vac_calculation",
              value: "+",
              relationalOperator: "===",
              logicalOperator: "||",
            },
          ],
        },
      },
    ],
    rowsOtherDetail: [],
    rowsOtherDetail1: [],
    Type: ["Paid", "Remain"],
    rowsCountOtherDetail: 0,
    rowsCountOtherDetail1: 0,

    rowsPerPageOtherDetail: 10,
    rowsPerPageOtherDetail1: 10,

    Displaybtn: false,

    columnsPaymentMode: [
      // { id: "Action", label: "Search", name: "Search" },
      // { id: 'bint_srno', label: 'SR NO' },
      { id: "vac_ledgername", label: "Payment Mode Ledger" },
      {
        id: "dec_amount",
        label: "Amount",
        type: "CtTxtAmt",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "vac_chequeno",
        label: "Cheque No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "vac_referenceno",
        label: "Reference No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "dat_transactiondate",
        label: "Transaction Date",
        type: "CtDtp",
        CtrlProps: { value: "", maxLength: 20 },
      },
      {
        id: "vac_remark",
        label: "Remark",
        type: "CtMultiLineText",
        CtrlProps: { value: "", width: 120, maxLength: 100 },
      },
      { id: "vac_groupname", label: "Group Name", hide: true },
    ],
    rowsPaymentMode: [],
    rowsCountPaymentMode: 0,
    rowsPerPagePaymentMode: 5,
    DefaultEntrySettingList: [],
    PaymentData: [],
    PaymentmodeListCols: [
      "bint_acid",
      "bint_ledgercode",
      "bint_ledgeridsrno",
      "dec_opbalance",
      "vac_backgroundprocess",
      "vac_company",
      "vac_firmname",
      "vac_groupheader",
      "vac_groupname",
      "vac_gstno",
      "vac_ledgername",
    ],
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Sales Entry";
    this.props.setActiveMenu("SalesEntry");
    this.setSearchColumns();
    this.ShortCut();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges,
    );
    window.addEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate() {
    const { formData } = this.state;
    let rowsTotal = getRowColSum(this.state.rows, [
      "dec_cgstamt",
      "dec_sgstamt",
      "dec_igstamt",
    ]);
    // console.log("rowtotal", rowsTotal);

    let CGST =
      Number(formData.txtCGST) !== 0
        ? Number(formData.txtCGST)
        : Number(rowsTotal.dec_cgstamt || 0) + Number(formData.tblCGST || 0);
    // console.log("CGST", CGST);

    let SGST =
      Number(formData.txtSGST) !== 0
        ? Number(formData.txtSGST)
        : Number(rowsTotal.dec_sgstamt || 0) + Number(formData.tblSGST || 0);
    // console.log("SGST", SGST);

    let IGST =
      Number(formData.txtIGST) !== 0
        ? Number(formData.txtIGST)
        : Number(rowsTotal.dec_igstamt || 0) + Number(formData.tblIGST || 0);
    // console.log("IGST", IGST);

    let txtsubtotal1 =
      Number(formData.txtTaxable) +
      Number(this.state.totalBeforeTaxAmt) +
      CGST +
      SGST +
      IGST +
      Number(this.state.totalAfterTaxAmt);
    // console.log("txtsubtotal1", txtsubtotal1);

    let NetPayment =
      Number(txtsubtotal1) -
      Number(formData.txtTDSAmount) -
      Number(formData.txtAdvPayment);
    let arrNetPayment = getRoundOff(NetPayment);
    let calculatedNetPayment = arrNetPayment["roff_number"];
    // console.log("calculatedNetPayment", calculatedNetPayment);

    if (formData.txtNetPayment !== calculatedNetPayment) {
      this.setState(
        (prevState) => {
          const targetLedgerNames = prevState.DefaultEntrySettingList.map(
            (row) => row.vac_ledgername,
          ).filter(Boolean);
          const rowsWithAmount = prevState.rowsPaymentMode.filter(
            (row) => row.dec_amount && row.dec_amount !== 0,
          );
          const decAmountCount = rowsWithAmount.length;
          const updatedRowsPaymentMode = prevState.rowsPaymentMode.map(
            (row) => {
              if (
                decAmountCount === 1 &&
                row.dec_amount &&
                row.dec_amount !== 0
              ) {
                return {
                  ...row,
                  dec_amount: parseFloat(calculatedNetPayment),
                };
              } else if (
                decAmountCount === 0 &&
                (!row.dec_amount || row.dec_amount == 0) &&
                targetLedgerNames.includes(row.vac_ledgername) &&
                (typeof row.chk_paymentmode === "undefined" ||
                  row.chk_paymentmode === true)
              ) {
                return {
                  ...row,
                  dec_amount: parseFloat(calculatedNetPayment),
                };
              }
              return row;
            },
          );

          return {
            formData: {
              ...prevState.formData,
              txtNetPayment: calculatedNetPayment,
            },
            rowsPaymentMode: updatedRowsPaymentMode,
          };
        },
        () => {
          console.log("Updated payment modes:", this.state.rowsPaymentMode);
        },
      );
      // this.setState((prevState) => ({
      //   formData: {
      //     ...prevState.formData,
      //     txtNetPayment: calculatedNetPayment,
      //   },
      // }));
    }
  }
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
    window.removeEventListener("scroll", this.handleScroll);
  }

  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "cmbBillType") {
          this.getBillNo();
        } else if (e.target.name === "cmbCustomer") {
          this.getStateCodeOFCustomer();
        } else if (
          e.target.name === "txtAdvPayment" ||
          e.target.name === "txtTDSAmount"
        ) {
          this.componentDidUpdate();
        }
        if (e.target.name === "cmbTransactionType") {
          if (
            this.state.formData.cmbTransactionType === "Paid" &&
            !this.state.isInitialLoad &&
            !this.state.hasOpenedTransactionType
          ) {
            this.handleSelectTransactionType();
          }
          // Reset initial load after first change
          if (this.state.isInitialLoad) {
            this.setState({ isInitialLoad: false });
          }
        } else if (this.state.formData.cmbTransactionType === "Remain") {
          this.setState({ hasOpenedTransactionType: false });
        }
        // this.calNetAmount();

        // if (e.target.name === "") {
        //   this.getrowsPaymentMode();
        // }
      },
    );
  };

  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };
  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickSave: this.saveSales,
        handleOnclickPrint: () => {
          this.trimFormData(() => {
            this.saveSales(true);
          });
        },
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: this.onDeleteBtnClick,
        handleOnclickPluse: this.handleDynamicShortcut,
        handleOnclickAdd: this.handleOnNewEntryClick,
        // handleOnclickPrint: this.openInvoiceARDSelection,
        handleOnclickList: () => {
          this.props.navigateTo("SalesList");
        },
      }),
    });
  };
  handleDynamicShortcut = () => {
    const activeElement = document.activeElement;

    if (!activeElement) return;

    const elementId = activeElement.id;

    switch (elementId) {
      case "cmbCustomer":
      case "cmbShipTo":
        this.onAddClickCustomer();
        break;
      case "cmbReference":
        this.onAddClickReference();
        break;
      case "txtInvoiceARD":
        this.openInvoiceARDSelection();
        break;
      default:
      // console.log("No handler found for element:", elementId);
    }
  };

  // handleARDonActionClick = (row) => {
  //   // console.log("call");

  //   // console.log("row", row);

  //   let bint_itemsrno = row.bint_itemsrno,
  //     vac_itemname = row.vac_itemname,
  //     actionName = row.actionName,
  //     edit_salessrno = row.bint_salessrno,
  //     bint_acyear = localStorage.getItem("ACY"),
  //     bint_acid = localStorage.getItem("acid"),
  //     EditSalesItemData = [],
  //     CustomerStateCode = "",
  //     CustomerData = [];

  //   if (actionName === "Edit") {
  //     let ARD = null;
  //     EditSalesItemData = [
  //       {
  //         bint_itemsrno: row.bint_itemsrno,
  //         vac_itemname: row.vac_itemname,
  //         vac_hsncode: row.vac_hsncode,
  //         vac_unit: row.vac_unit,
  //         dec_qty: row.dec_qty,
  //         dec_rate: row.dec_rate,
  //         dec_basicamt: row.dec_basicamt,
  //         dec_disper: row.dec_disper,
  //         dec_disamt: row.dec_disamt,
  //         dec_taxable: row.dec_taxable,
  //         vac_taxname: row.vac_taxname,
  //         dec_cgstamt: row.dec_cgstamt,
  //         dec_sgstamt: row.dec_sgstamt,
  //         dec_igstamt: row.dec_igstamt,
  //         dec_totalamt: row.dec_totalamt,
  //         vac_remark: row.vac_remark,
  //         vac_storename: row.vac_storename,
  //       },
  //     ];
  //     this.setState({ ARD }, () => {
  //       ARD = (
  //         <AlertResponsiveDialog
  //           labelDisagree="Close"
  //           // Edit : Sales Item Entry
  //           alertMessage={
  //             <SalesItemEntry
  //               bint_itemsrno={bint_itemsrno}
  //               edit_salessrno={edit_salessrno}
  //               getItemList={this.getItemList}
  //               refreshSalesItemList={this.refreshSalesItemList}
  //               resetAmount={this.resetAmount}
  //               bint_acid={localStorage.getItem("acid")}
  //               bint_acyear={localStorage.getItem("ACY")}
  //               ItemNameList={this.state.ItemNameList}
  //               PackingList={this.state.PackingList}
  //               TaxNameList={this.state.TaxNameList}
  //               StoreList={this.state.StoreList}
  //               EditSalesItemData={EditSalesItemData}
  //               dtpDate={this.state.formData.dtpDate}
  //               dtpDueDate={this.state.formData.dtpDueDate}
  //               cmbCompany={localStorage.getItem("CompanyName")}
  //               cmbBillType={this.state.formData.cmbBillType}
  //               txtBillNo={this.state.formData.LblBillNo}
  //               bint_billno={this.state.formData.txtBillNo}
  //               cmbCustomer={this.state.formData.cmbCustomer}
  //               cmbReference={this.state.formData.cmbReference}
  //               CustomerStateCode={this.state.CustomerStateCode}
  //               CustomerData={this.state.CustomerData}
  //               cmbShipTo={this.state.formData.cmbShipTo}
  //               txtOtherDetail={this.state.formData.txtOtherDetail}
  //               txtDiscount={this.state.formData.txtDiscount}
  //               txtTaxable={this.state.formData.txtTaxable}
  //               txtCGST={this.state.formData.txtCGST}
  //               txtSGST={this.state.formData.txtSGST}
  //               txtIGST={this.state.formData.txtIGST}
  //               txtGrandTotal={this.state.formData.txtGrandTotal}
  //               txtTDSAmount={this.state.formData.txtTDSAmount}
  //               txtAdvPayment={this.state.formData.txtAdvPayment}
  //               txtNetPayment={this.state.formData.txtNetPayment}
  //               txtRoundOff={this.state.formData.txtRoundOff}
  //               cmbTransactionType={this.state.formData.cmbTransactionType}
  //               txtRemark={this.state.formData.txtRemark}
  //               rowsPaymentMode={this.state.rowsPaymentMode}
  //               rowsOtherDetail={this.state.rowsOtherDetail}
  //               rowsOtherDetail1={this.state.rowsOtherDetail1}
  //               dec_beforetaxamt={this.state.totalBeforeTaxAmt}
  //               dec_aftertaxamt={this.state.totalAfterTaxAmt}
  //               txtbasicamt={this.state.formData.txtbasicamt}
  //               totalafterDeductionTaxamt={this.state.totalafterDeductionTaxamt}
  //               totalAfteraddTaxamt={this.state.totalAfteraddTaxamt}
  //               totalBeforeaddTaxamt={this.state.totalBeforeaddTaxamt}
  //               totalBeforeDeductionTaxamt={
  //                 this.state.totalBeforeDeductionTaxamt
  //               }
  //               chkReceiptGenerated={this.state.formData.chkReceiptGenerated}
  //             />
  //           }
  //           defaultOpenDialog={true}
  //           onYesClickCloseIfExeSuccessfully={true}
  //         />
  //       );
  //       this.setState({ ARD });
  //     });
  //   } else if (actionName === "Delete") {
  //     this.setState({ ARD: null }, () => {
  //       let ARD = (
  //         <AlertResponsiveDialog
  //           labelAgree="Delete"
  //           labelDisagree="Cancel"
  //           alertTitle={"Do you want to Delete Item : " + vac_itemname + " ?"}
  //           alertMessage=""
  //           handleOnClickYes={() => {
  //             return this.deleteSalesItem(
  //               bint_acyear,
  //               bint_acid,
  //               edit_salessrno,
  //               bint_itemsrno
  //             );
  //           }}
  //           defaultOpenDialog={true}
  //           onYesClickCloseIfExeSuccessfully={true}
  //         />
  //       );

  //       this.setState({ ARD });
  //     });
  //   }
  // };

  handleARDonActionClick_Delete = (rtRow) => {
    // console.log("this.state.rows", this.state.rows);

    const row = getRowOfRT(rtRow, [
      "vac_itemname",
      "bint_itemsrno",
      "bint_salessrno",
      "vac_itemname",
      "vac_hsncode",
      "vac_unit",
      "dec_qty",
      "dec_rate",
      "dec_basicamt",
      "dec_disper",
      "dec_disamt",
      "dec_taxable",
      "vac_taxname",
      "dec_cgstamt",
      "dec_sgstamt",
      "dec_igstamt",
      "dec_totalamt",
      "vac_remark",
      "vac_storename",
    ]);
    const vac_itemname = row.vac_itemname,
      bint_itemsrno = row.bint_itemsrno,
      edit_salessrno = row.bint_salessrno,
      bint_acyear = localStorage.getItem("ACY"),
      bint_acid = localStorage.getItem("acid");

    this.setState({ ARD: null }, () => {
      let ARD = null;
      if (this.state.rows.length == 1) {
        ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete Sales Entry"
            labelDisagree="Add New Sales Item"
            alertTitle={"This is the only item in the sale!"}
            alertMessage="Deleting this will remove the entire sale. Please add a new item first if you want to keep the sale."
            handleOnClickYes={() => {
              return this.deleteSales(edit_salessrno);
            }}
            handleOnClickNo={this.handleOnNewEntryClick}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
      } else {
        ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete Item : " + vac_itemname + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteSalesItem(
                bint_acyear,
                bint_acid,
                edit_salessrno,
                bint_itemsrno,
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
      }

      this.setState({ ARD });
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    let EditSalesItemData = [];
    const row = getRowOfRT(rtRow, [
      "vac_itemname",
      "bint_itemsrno",
      "bint_salessrno",
      "vac_itemname",
      "vac_hsncode",
      "vac_unit",
      "dec_qty",
      "dec_rate",
      "dec_basicamt",
      "dec_disper",
      "dec_disamt",
      "dec_taxable",
      "vac_taxname",
      "dec_cgstamt",
      "dec_sgstamt",
      "dec_igstamt",
      "dec_totalamt",
      "vac_remark",
      "vac_storename",
    ]);

    const vac_itemname = row.vac_itemname,
      bint_itemsrno = row.bint_itemsrno,
      edit_salessrno = row.bint_salessrno,
      bint_acyear = localStorage.getItem("ACY"),
      bint_acid = localStorage.getItem("acid");

    let ARD = null;
    EditSalesItemData = [
      {
        bint_itemsrno: row.bint_itemsrno,
        vac_itemname: row.vac_itemname,
        vac_hsncode: row.vac_hsncode,
        vac_unit: row.vac_unit,
        dec_qty: row.dec_qty,
        dec_rate: row.dec_rate,
        dec_basicamt: row.dec_basicamt,
        dec_disper: row.dec_disper,
        dec_disamt: row.dec_disamt,
        dec_taxable: row.dec_taxable,
        vac_taxname: row.vac_taxname,
        dec_cgstamt: row.dec_cgstamt,
        dec_sgstamt: row.dec_sgstamt,
        dec_igstamt: row.dec_igstamt,
        dec_totalamt: row.dec_totalamt,
        vac_remark: row.vac_remark,
        vac_storename: row.vac_storename,
      },
    ];

    let rowsOtherDetail = this.state.rowsOtherDetail.filter(
      (row) => row.vac_calculation === "",
    );

    let rowsOtherDetail1 = this.state.rowsOtherDetail1.filter(
      (row) => row.vac_calculation !== "",
    );
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree=""
          // Edit : Sales Item Entry
          alertMessage={
            <SalesItemEntry
              bint_itemsrno={bint_itemsrno}
              edit_salessrno={edit_salessrno}
              getItemList={this.getItemList}
              refreshSalesItemList={this.refreshSalesItemList}
              resetAmount={this.resetAmount}
              bint_acid={localStorage.getItem("acid")}
              bint_acyear={localStorage.getItem("ACY")}
              ItemNameList={this.state.ItemNameList}
              PackingList={this.state.PackingList}
              TaxNameList={this.state.TaxNameList}
              StoreList={this.state.StoreList}
              EditSalesItemData={EditSalesItemData}
              dtpDate={this.state.formData.dtpDate}
              dtpDueDate={this.state.formData.dtpDueDate}
              cmbCompany={localStorage.getItem("CompanyName")}
              cmbBillType={this.state.formData.cmbBillType}
              txtBillNo={this.state.formData.LblBillNo}
              bint_billno={this.state.formData.txtBillNo}
              cmbCustomer={this.state.formData.cmbCustomer}
              cmbReference={this.state.formData.cmbReference}
              CustomerStateCode={this.state.CustomerStateCode}
              CustomerData={this.state.CustomerData}
              cmbShipTo={this.state.formData.cmbShipTo}
              txtOtherDetail={this.state.formData.txtOtherDetail}
              txtDiscount={this.state.formData.txtDiscount}
              txtTaxable={this.state.formData.txtTaxable}
              txtCGST={this.state.formData.txtCGST}
              txtSGST={this.state.formData.txtSGST}
              txtIGST={this.state.formData.txtIGST}
              txtGrandTotal={this.state.formData.txtGrandTotal}
              txtTDSAmount={this.state.formData.txtTDSAmount}
              txtAdvPayment={this.state.formData.txtAdvPayment}
              txtNetPayment={this.state.formData.txtNetPayment}
              txtRoundOff={this.state.formData.txtRoundOff}
              cmbTransactionType={this.state.formData.cmbTransactionType}
              txtRemark={this.state.formData.txtRemark}
              rowsPaymentMode={this.state.rowsPaymentMode}
              OtherDetailData={[...rowsOtherDetail, ...rowsOtherDetail1]}
              dec_beforetaxamt={this.state.totalBeforeTaxAmt}
              dec_aftertaxamt={this.state.totalAfterTaxAmt}
              txtbasicamt={this.state.formData.txtbasicamt}
              totalafterDeductionTaxamt={this.state.totalafterDeductionTaxamt}
              totalAfteraddTaxamt={this.state.totalAfteraddTaxamt}
              totalBeforeaddTaxamt={this.state.totalBeforeaddTaxamt}
              totalBeforeDeductionTaxamt={this.state.totalBeforeDeductionTaxamt}
              chkReceiptGenerated={this.state.formData.chkReceiptGenerated}
              salesRowsCount={this.state.rows.length}
              deleteSales={this.deleteSales}
              closeARD={this.closeARD}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };
  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
      },
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_storename.length === 0 ||
            (row["vac_storename"] &&
              row["vac_storename"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_storename.toLowerCase(),
                ))) &&
          (this.state.searchData.vac_itemname.length === 0 ||
            (row["vac_itemname"] &&
              row["vac_itemname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_itemname.toLowerCase()))) &&
          (this.state.searchData.vac_hsncode.length === 0 ||
            (row["vac_hsncode"] &&
              row["vac_hsncode"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_hsncode.toLowerCase()))) &&
          (this.state.searchData.vac_taxname.length === 0 ||
            (row["vac_taxname"] &&
              row["vac_taxname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_taxname.toLowerCase()))) &&
          (this.state.searchData.vac_unit.length === 0 ||
            (row["vac_unit"] &&
              row["vac_unit"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_unit.toLowerCase()))) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (row["vac_remark"] &&
              row["vac_remark"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_remark.toLowerCase()))) &&
          (this.state.searchData.dec_qty.length === 0 ||
            (row["dec_qty"] &&
              Number(row["dec_qty"]) ==
                Number(this.state.searchData.dec_qty))) &&
          (this.state.searchData.dec_rate.length === 0 ||
            (row["dec_rate"] &&
              Number(row["dec_rate"]) ==
                Number(this.state.searchData.dec_rate)))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {},
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnNewEntryClick = () => {
    if (this.validateSales() === true) {
      let ARD = null;

      let rowsOtherDetail = this.state.rowsOtherDetail.filter(
        (row) => row.vac_calculation === "",
      );

      let rowsOtherDetail1 = this.state.rowsOtherDetail1.filter(
        (row) => row.vac_calculation !== "",
      );

      // console.log("rowsOtherDetail sales entry", rowsOtherDetail);
      // console.log("rowsOtherDetail1 sales entry", rowsOtherDetail1);

      this.setState({ ARD }, () => {
        this.removeKeyboardShortCuts();
        ARD = (
          <AlertResponsiveDialog
            labelDisagree=""
            // New : Sales Item Entry'
            alertMessage={
              <SalesItemEntry
                refreshSalesItemList={this.refreshSalesItemList}
                getItemList={this.getItemList}
                resetAmount={this.resetAmount}
                bint_acid={localStorage.getItem("acid")}
                bint_acyear={localStorage.getItem("ACY")}
                ItemNameList={this.state.ItemNameList}
                PackingList={this.state.PackingList}
                TaxNameList={this.state.TaxNameList}
                StoreList={this.state.StoreList}
                edit_salessrno={this.state.formData.edit_salessrno}
                dtpDate={this.state.formData.dtpDate}
                dtpDueDate={this.state.formData.dtpDueDate}
                cmbCompany={localStorage.getItem("CompanyName")}
                cmbBillType={this.state.formData.cmbBillType}
                txtBillNo={this.state.formData.LblBillNo}
                bint_billno={this.state.formData.txtBillNo}
                cmbCustomer={this.state.formData.cmbCustomer}
                cmbReference={this.state.formData.cmbReference}
                CustomerStateCode={this.state.CustomerStateCode}
                CustomerData={this.state.CustomerData}
                cmbShipTo={this.state.formData.cmbShipTo}
                txtOtherDetail={this.state.formData.txtOtherDetail}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtTDSAmount={this.state.formData.txtTDSAmount}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtNetPayment={this.state.formData.txtNetPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                cmbTransactionType={this.state.formData.cmbTransactionType}
                txtRemark={this.state.formData.txtRemark}
                rowsPaymentMode={this.state.rowsPaymentMode}
                OtherDetailData={[...rowsOtherDetail, ...rowsOtherDetail1]}
                dec_beforetaxamt={this.state.totalBeforeTaxAmt}
                dec_aftertaxamt={this.state.totalAfterTaxAmt}
                txtbasicamt={this.state.formData.txtbasicamt}
                totalafterDeductionTaxamt={this.state.totalafterDeductionTaxamt}
                totalAfteraddTaxamt={this.state.totalAfteraddTaxamt}
                totalBeforeaddTaxamt={this.state.totalBeforeaddTaxamt}
                totalBeforeDeductionTaxamt={
                  this.state.totalBeforeDeductionTaxamt
                }
                closeARD={this.closeARD}
                // onSuccessfulSalesItemEntry={this.updateStateInfo}
              />
            }
            handleOnClickNo={() => {
              this.ShortCut();
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  closeARD = () => {
    this.setState({ ARD: null });
  };

  setEwayBillARDNull = (EWayBillData) => {
    this.setState({ ARD: null, EWayBillData });
  };

  ewaybillprocess = () => {
    if (this.validateSales() === true) {
      let ARD = null;
      this.setState({ ARD }, () => {
        ARD = (
          <AlertResponsiveDialog
            fullscreenOnly={true}
            labelDisagree="Close"
            alertMessage={
              <SalesEWayBill
                setEwayBillARDNull={this.setEwayBillARDNull}
                EWayBillData={this.state.EWayBillData}
                StateList={this.state.StateList}
                resetAmount={this.resetAmount}
                bint_acid={localStorage.getItem("acid")}
                bint_acyear={localStorage.getItem("ACY")}
                ItemNameList={this.state.ItemNameList}
                PackingList={this.state.PackingList}
                TaxNameList={this.state.TaxNameList}
                StoreList={this.state.StoreList}
                edit_salessrno={this.state.formData.edit_salessrno}
                dtpDate={this.state.formData.dtpDate}
                dtpDueDate={this.state.formData.dtpDueDate}
                cmbCompany={localStorage.getItem("CompanyName")}
                cmbBillType={this.state.formData.cmbBillType}
                txtBillNo={this.state.formData.LblBillNo}
                bint_billno={this.state.formData.txtBillNo}
                cmbCustomer={this.state.formData.cmbCustomer}
                cmbReference={this.state.formData.cmbReference}
                CustomerStateCode={this.state.CustomerStateCode}
                CustomerData={this.state.CustomerData}
                cmbShipTo={this.state.formData.cmbShipTo}
                txtOtherDetail={this.state.formData.txtOtherDetail}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtTDSAmount={this.state.formData.txtTDSAmount}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtNetPayment={this.state.formData.txtNetPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                cmbTransactionType={this.state.formData.cmbTransactionType}
                txtRemark={this.state.formData.txtRemark}
                rowsPaymentMode={this.state.rowsPaymentMode}
                rowsOtherDetail={this.state.rowsOtherDetail}
                rowsOtherDetail1={this.state.rowsOtherDetail1}
                dec_beforetaxamt={this.state.totalBeforeTaxAmt}
                dec_aftertaxamt={this.state.totalAfterTaxAmt}
                txtbasicamt={this.state.formData.txtbasicamt}
                totalafterDeductionTaxamt={this.state.totalafterDeductionTaxamt}
                totalAfteraddTaxamt={this.state.totalAfteraddTaxamt}
                totalBeforeaddTaxamt={this.state.totalBeforeaddTaxamt}
                totalBeforeDeductionTaxamt={
                  this.state.totalBeforeDeductionTaxamt
                }
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleChangeRowsPerPageOtherDetail1 = (rowsPerPageOtherDetail1) => {
    this.setState({ rowsPerPageOtherDetail1 });
  };
  handleOnNewEntryClickOtherDetail = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={<DetailMaster />}
          defaultOpenDialog={true}
          handleOnClickNo={this.getDetailList}
        />
      );
      this.setState({ ARD });
    });
  };

  handleChangeRowsPerPagePaymentMode = (rowsPerPagePaymentMode) => {
    this.setState({ rowsPerPagePaymentMode });
  };

  handleOnRowDataChangeOtherDetail = (
    rowsOtherDetail,
    handledRowIndex,
    colID,
  ) => {
    let totalBeforeTaxAmt = 0;
    let totalAfterTaxAmt = 0;
    let totalAfteraddTaxamt = 0;
    let totalafterDeductionTaxamt = 0;
    let totalBeforeaddTaxamt = 0;
    let totalBeforeDeductionTaxamt = 0;

    let tblCGST = 0,
      tblSGST = 0,
      minustblIGST = 0,
      plustblIGST = 0;

    if (isNumeric(this.state.formData.tblCGST)) {
      tblCGST = Number(this.state.formData.tblCGST);
    }
    if (isNumeric(this.state.formData.tblSGST)) {
      tblSGST = Number(this.state.formData.tblSGST);
    }
    if (isNumeric(this.state.formData.tblIGST)) {
      minustblIGST = Number(this.state.formData.tblIGST);
      plustblIGST = Number(this.state.formData.tblIGST);
    }

    rowsOtherDetail.forEach((row) => {
      if (isNumeric(row["vac_value"])) {
        let value = Number(row["vac_value"]);

        if (row["vac_taxname"] && row["vac_calculation"] == "+") {
          totalBeforeTaxAmt += value;
          totalBeforeaddTaxamt += value;

          let result = this.taxCalcualte(
            row,
            "+",
            tblCGST,
            tblSGST,
            plustblIGST,
          );

          tblCGST = Number(result.tblCGST);
          tblSGST = Number(result.tblSGST);
          plustblIGST = Number(result.tblIGST);
        } else if (row["vac_taxname"] && row["vac_calculation"] == "-") {
          totalBeforeTaxAmt -= value;
          totalBeforeDeductionTaxamt -= value;

          let result = this.taxCalcualte(
            row,
            "-",
            tblCGST,
            tblSGST,
            minustblIGST,
          );

          tblCGST = Number(result.tblCGST);
          tblSGST = Number(result.tblSGST);
          minustblIGST = Number(result.tblIGST);
        } else if (
          row["vac_calculationstyle"] == "After Tax" &&
          row["vac_calculation"] == "+"
        ) {
          totalAfterTaxAmt += value;
          totalAfteraddTaxamt += value;
        } else if (
          row["vac_calculationstyle"] == "After Tax" &&
          row["vac_calculation"] == "-"
        ) {
          totalAfterTaxAmt -= value;
          totalafterDeductionTaxamt -= value;
        }
      }
    });

    let tblIGST = Number(plustblIGST) + Number(minustblIGST);

    this.setState({
      rowsOtherDetail,
      rowsCountOtherDetail: rowsOtherDetail.length,
    });
  };

  // handleOnRowDataChangeOtherDetail = (
  //   rowsOtherDetail,
  //   handledRowIndex,
  //   colID,
  // ) => {
  //   this.setState(
  //     {
  //       formData: {
  //         ...this.state.formData,
  //       },
  //     },
  //     () => {
  //       let totalBeforeTaxAmt = 0;
  //       let totalAfterTaxAmt = 0;
  //       let totalAfteraddTaxamt = 0;
  //       let totalafterDeductionTaxamt = 0;
  //       let totalBeforeaddTaxamt = 0;
  //       let totalBeforeDeductionTaxamt = 0;
  //       let tblCGST = 0,
  //         tblSGST = 0,
  //         minustblIGST = 0,
  //         plustblIGST = 0;
  //       if (isNumeric(this.state.formData.tblCGST)) {
  //         tblCGST = Number(this.state.formData.tblCGST);
  //       }
  //       if (isNumeric(this.state.formData.tblSGST)) {
  //         tblSGST = Number(this.state.formData.tblSGST);
  //       }
  //       if (isNumeric(this.state.formData.tblIGST)) {
  //         minustblIGST = Number(this.state.formData.tblIGST);
  //         plustblIGST = Number(this.state.formData.tblIGST);
  //       }
  //       rowsOtherDetail.map((row, index) => {
  //         if (isNumeric(row["vac_value"])) {
  //           let value = Number(row["vac_value"]);
  //           if (row["vac_taxname"] && row["vac_calculation"] == "+") {
  //             totalBeforeTaxAmt += value;
  //             totalBeforeaddTaxamt += value;

  //             let result = this.taxCalcualte(
  //               row,
  //               "+",
  //               tblCGST,
  //               tblSGST,
  //               plustblIGST,
  //             );
  //             tblCGST = Number(result.tblCGST);
  //             tblSGST = Number(result.tblSGST);
  //             plustblIGST = Number(result.tblIGST);
  //           } else if (row["vac_taxname"] && row["vac_calculation"] == "-") {
  //             totalBeforeTaxAmt -= value;
  //             totalBeforeDeductionTaxamt -= value;

  //             let result = this.taxCalcualte(
  //               row,
  //               "-",
  //               tblCGST,
  //               tblSGST,
  //               minustblIGST,
  //             );
  //             tblCGST = Number(result.tblCGST);
  //             tblSGST = Number(result.tblSGST);
  //             minustblIGST = Number(result.tblIGST);
  //           } else if (
  //             row["vac_calculationstyle"] == "After Tax" &&
  //             row["vac_calculation"] == "+"
  //           ) {
  //             totalAfterTaxAmt += value;
  //             totalAfteraddTaxamt += value;
  //           } else if (
  //             row["vac_calculationstyle"] == "After Tax" &&
  //             row["vac_calculation"] == "-"
  //           ) {
  //             totalAfterTaxAmt -= value;
  //             totalafterDeductionTaxamt -= value;
  //           }
  //         }
  //       });

  //       // console.log("rowsOtherDetail", rowsOtherDetail);

  //       let tblIGST = Number(plustblIGST) + Number(minustblIGST);

  //       this.setState(
  //         {
  //           rowsOtherDetail,
  //           rowsCountOtherDetail: rowsOtherDetail.length,

  //           formData: {
  //             ...this.state.formData,
  //           },
  //         },
  //         () => {
  //           // this.calNetAmount();
  //         },
  //       );
  //     },
  //   );
  // };

  handleOnRowDataChangeOtherDetail1 = (
    rowsOtherDetail1,

    handledRowIndex,
    colID,
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          tblCGST: 0,
          tblSGST: 0,
          tblIGST: 0,
        },
      },
      () => {
        let totalBeforeTaxAmt = 0;
        let totalAfterTaxAmt = 0;
        let totalAfteraddTaxamt = 0;
        let totalafterDeductionTaxamt = 0;
        let totalBeforeaddTaxamt = 0;
        let totalBeforeDeductionTaxamt = 0;
        let tblCGST = 0,
          tblSGST = 0,
          minustblIGST = 0,
          plustblIGST = 0;
        if (isNumeric(this.state.formData.tblCGST)) {
          tblCGST = Number(this.state.formData.tblCGST);
        }
        if (isNumeric(this.state.formData.tblSGST)) {
          tblSGST = Number(this.state.formData.tblSGST);
        }
        if (isNumeric(this.state.formData.tblIGST)) {
          minustblIGST = Number(this.state.formData.tblIGST);
          plustblIGST = Number(this.state.formData.tblIGST);
        }
        rowsOtherDetail1.map((row, index) => {
          if (isNumeric(row["vac_value"])) {
            let value = Number(row["vac_value"]);
            if (row["vac_taxname"] && row["vac_calculation"] == "+") {
              totalBeforeTaxAmt += value;
              totalBeforeaddTaxamt += value;

              let result = this.taxCalcualte(
                row,
                "+",
                tblCGST,
                tblSGST,
                plustblIGST,
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              plustblIGST = Number(result.tblIGST);
            } else if (row["vac_taxname"] && row["vac_calculation"] == "-") {
              totalBeforeTaxAmt -= value;
              totalBeforeDeductionTaxamt -= value;

              let result = this.taxCalcualte(
                row,
                "-",
                tblCGST,
                tblSGST,
                minustblIGST,
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              minustblIGST = Number(result.tblIGST);
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "+"
            ) {
              totalAfterTaxAmt += value;
              totalAfteraddTaxamt += value;
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "-"
            ) {
              totalAfterTaxAmt -= value;
              totalafterDeductionTaxamt -= value;
            }
          }
        });

        let tblIGST = Number(plustblIGST) + Number(minustblIGST);

        this.setState(
          {
            rowsOtherDetail1,
            rowsCountOtherDetail1: rowsOtherDetail1.length,
            totalBeforeTaxAmt,
            totalAfterTaxAmt,
            totalAfteraddTaxamt,
            totalafterDeductionTaxamt,
            totalBeforeDeductionTaxamt,
            totalBeforeaddTaxamt,
            formData: {
              ...this.state.formData,
              tblCGST: Number(tblCGST),
              tblSGST: Number(tblSGST),
              tblIGST: Number(tblIGST),
              txtCGST: 0,
              txtSGST: 0,
              txtIGST: 0,
            },
          },
          () => {
            // this.calNetAmount();
          },
        );
      },
    );
  };

  taxCalcualte = (row, icon, tblCGST, tblSGST, tblIGST) => {
    if (isNumeric(row["vac_value"])) {
      let value = Number(row["vac_value"]);
      if (row["vac_taxname"].length > 0) {
        const txtTaxable = value,
          TaxName = getTaxNumFromStr(row["vac_taxname"]);

        if (Number(txtTaxable) != 0 && Number(TaxName) >= 0) {
          tblCGST =
            icon == "+"
              ? tblCGST + (txtTaxable * (TaxName / 2)) / 100
              : tblCGST - (txtTaxable * (TaxName / 2)) / 100;
          tblCGST = Number(tblCGST);
          tblCGST = tblCGST.toFixed(2);
          tblSGST = tblCGST;

          if (
            this.state.CustomerStateCode !=
            localStorage.getItem("CompStateCode")
          ) {
            tblIGST = Number(tblCGST) + Number(tblSGST);
            tblCGST = 0;
            tblSGST = 0;
          }
        }
      }
    }
    return { tblCGST, tblSGST, tblIGST };

    /* this.setState(
      {
        formData: {
          ...this.state.formData,
          tblCGST: Number(tblCGST),
          tblSGST: Number(tblSGST),
          tblIGST: Number(tblIGST),
        },
      },
      () => {
        
      }
    ); */
  };

  // balnkTaxCalculate = (totalBeforeTaxAmt) => {
  //   if (totalBeforeTaxAmt == 0) {
  //     this.setState({
  //       formData: {
  //         ...this.state.formData,
  //         tblCGST: 0,
  //         tblSGST: 0,
  //         tblIGST: 0,
  //       },
  //     });
  //   }
  // };

  handleOnRowDataChangePaymentMode = (
    rowsPaymentMode,
    handledRowIndex,
    colID,
  ) => {
    this.setState({
      rowsPaymentMode,
      rowsCountPaymentMode: rowsPaymentMode.length,
    });
  };

  handleOnChkChange = (e) => {
    if (this.getAdvancePaidAccessStatus()) {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            [e.target.name]: e.target.checked,
          },
        },
        () => {},
      );
    } else {
      this.setState({
        formData: {
          ...this.state.formData,
          [e.target.name]: false,
        },
      });
    }
  };
  //#endregion handle

  //#region function
  getEnabledAdvPaymentStatus = () => {
    if (this.state.formData.cmbTransactionType === "Paid") {
      return false;
    } else {
      return true;
    }
  };

  getAdvancePaidAccessStatus = () => {
    return (
      this.state.rowsCount >= 1 && Number(this.state.formData.txtAdvPayment) > 0
    );
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "Lbl",
        label: "Sr. No.",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_storename",
        // items: this.state.ItemName,
        label: "Item Name",
        value: this.state.searchData.vac_storename,
        handleOnChange: this.handleOnSearchInputChange,
        width: "120",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_itemname",
        maxLength: "100",
        // items: this.state.ItemName,
        label: "Item Name",
        value: this.state.searchData.vac_itemname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "120",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_hsncode",
        label: "HSN",
        value: this.state.searchData.vac_hsncode,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_unit",
        // items: this.state.Packing,
        label: "Packing",
        value: this.state.searchData.vac_unit,
        handleOnChange: this.handleOnSearchInputChange,
        width: "110",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "dec_qty",
        label: "Quantity",
        value: this.state.searchData.dec_qty,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "dec_rate",
        label: "Rate",
        value: this.state.searchData.dec_rate,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_basicamt",
        label: "Basic Amount",
        value: this.state.searchData.dec_basicamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        label: "Dis (%)",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Dis Amt",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Taxable",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_taxname",
        // items: this.state.TaxName,
        label: "Tax Name",
        value: this.state.searchData.vac_taxname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "110",
        // colID: 'status',
      },
      {
        cType: "Lbl",
        id: "dec_cgstamt",
        label: "CGST",
        value: this.state.searchData.dec_cgstamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_sgstamt",
        label: "SGST",
        value: this.state.searchData.dec_sgstamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_igstamt",
        label: "IGST",
        value: this.state.searchData.dec_igstamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_totalamt",
        label: "Total amt",
        value: this.state.searchData.dec_totalamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "110",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
    );
    this.setState({ searchColumns }, () => {});
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chkReceiptGenerated"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateSales = () => {
    let result = false;
    if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpDate,
        "dtpDate",
        this.props.toastErrorMsg,
      ) == false
    ) {
      return false;
    } else if (this.state.formData.cmbBillType.length <= 0) {
      this.props.toastErrorMsg("Select Bill Type", "cmbBillType");
    } else if (this.state.formData.txtBillNo.length <= 0) {
      this.props.toastErrorMsg("Enter Bill No", "txtBillNo");
    } else if (this.state.formData.cmbCustomer.length <= 0) {
      this.props.toastErrorMsg("Select Customer Name", "cmbCustomer");
    } else if (
      isValidItem(
        this.state.Customer,
        "vac_customer",
        this.state.formData.cmbCustomer,
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Customer Name", "cmbCustomer");
    } else if (
      this.state.formData.cmbShipTo.length > 0 &&
      isValidItem(
        this.state.ShipTo,
        "vac_customer",
        this.state.formData.cmbShipTo,
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Ship to Name", "cmbShipTo");
    } else if (
      this.state.formData.cmbReference &&
      this.state.formData.cmbReference.length > 0 &&
      isValidItem(
        this.state.ReferenceList,
        "vac_referencename",
        this.state.formData.cmbReference,
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Reference Name", "cmbReference");
    } else if (this.state.formData.cmbTransactionType.length <= 0) {
      this.props.toastErrorMsg("Select Transaction Type", "cmbTransactionType");
    } else {
      result = true;
    }
    return result;
  };

  validateSalesItemCount = () => {
    // this.props.toastErrorMsg("validateSalesItemCount")
    let result = false;
    if (this.state.rowsCount <= 0) {
      this.props.toastErrorMsg("Enter atleast one item", "dtpDate");
    } else {
      result = true;
    }
    return result;
  };

  validatePaymentModeAmount = () => {
    let result = false,
      dec_amount = 0;
    // console.log("call1");

    if (
      this.getPaymentModeDataStatus &&
      this.state.rowsPaymentMode.length > 0
    ) {
      // console.log("call2");
      this.state.rowsPaymentMode.map((row) => {
        // console.log("call3");
        // console.log("call4", row.dec_amount);
        if (row.dec_amount != undefined) {
          dec_amount += Number(row.dec_amount);
        }
      });
      // console.log("call5", this.state.formData.cmbTransactionType);
      // console.log(
      //   "condition",
      //   this.state.formData.cmbTransactionType.trim() === "Paid"
      // );

      if (this.state.formData.cmbTransactionType === "Paid") {
        // console.log("call5");
        if (dec_amount == Number(this.state.formData.txtNetPayment)) {
          // console.log("call6");
          result = true;
        } else {
          // console.log("call7");
          this.props.toastErrorMsg(
            "Net Payment Amount and Payment Mode Ledger Amount must be same",
          );
        }
      } else if (this.state.formData.cmbTransactionType === "Remain") {
        // console.log("call8");
        result = true;
      }
    } else {
      result = true;
    }
    return result;
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState(
      { dataLoadStatus, autoResetFormData: false, isInitialLoad: true },
      () => {
        let bint_acyear = 0,
          bint_acid = "",
          edit_salessrno = 0;
        if (this.props.location.state && this.props.location.state != null) {
          this.setState({ isEditMode: true });
          bint_acid = this.props.location.state.bint_acid;
          edit_salessrno = this.props.location.state.bint_salessrno;
          bint_acyear = this.props.location.state.bint_acyear;
          let reqData = {
            Op: "SalesData",
            bint_acyear,
            bint_acid,
            edit_salessrno,
            vac_userid: localStorage.getItem("logInID"),
            bint_ci: localStorage.getItem("CI"),
          };
          fetchSales(reqData)
            .then((res) => {
              if (isCompanyChange(res.data.SalesList[0].vac_company)) {
                this.props.updateProcessing(res.data.msgType, res.data.message);
                let CompanyList = res.data.CompanyList,
                  Customer = res.data.CustomerList,
                  ShipTo = res.data.CustomerList,
                  TaxNameList = res.data.TaxList,
                  ItemNameList = res.data.ItemList,
                  StoreList = res.data.StoreList,
                  SalesInvoiceGeneration = "",
                  SalesInvoiceDefaultPrint = "",
                  IntSignature_StampPrint = 0,
                  InvoiceNoList = res.data.InvoiceNoList,
                  DefaultEntrySettingList = res.data.DefaultEntrySettingList,
                  rowsOtherDetail = [],
                  rowsOtherDetail1 = [],
                  rowsCountOtherDetail = rowsOtherDetail.length,
                  rowsCountOtherDetail1 = rowsOtherDetail1.length,
                  rows = [],
                  rowsCount = rows.length,
                  rowsPaymentMode = [],
                  rowsCountPaymentMode = rowsPaymentMode.length,
                  LedgerNameList = [],
                  DetailList = [],
                  ReferenceList = res.data.ReferenceList,
                  PaymentData = [],
                  EWayBillData = [],
                  ispaid = false,
                  StateList = [];
                let SalesInvoiceDefault_Print = "";
                let StrSignature_StampPrint = getRowData(
                  res.data.GeneralSettingList,
                  "vac_key",
                  "In Sales (Default)",
                );
                res.data.GeneralSettingList.map((row) => {
                  if (row.vac_module === "Sales") {
                    if (row.vac_key === "Sales Invoice Generation") {
                      SalesInvoiceGeneration = row.vac_value;
                    }
                    if (row.vac_key === "Sales Invoice Default Print") {
                      SalesInvoiceDefaultPrint = row.vac_value;
                    }
                  }
                  if (row.vac_module === "Signature & Stamp") {
                    if (row.vac_key === "In Sales (Default)") {
                      IntSignature_StampPrint =
                        StrSignature_StampPrint["vac_value"] === "Yes" ? 1 : 0;
                    }
                  }
                });

                if (
                  res.data.SalesItemData &&
                  res.data.SalesItemData.length > 0
                ) {
                  rows = this.addActionColStatus(res.data.SalesItemData);
                  rowsCount = rows.length;
                }
                if (res.data.EWayBillData) {
                  EWayBillData = res.data.EWayBillData;
                }
                if (res.data.StateList) {
                  StateList = res.data.StateList;
                }
                if (
                  res.data.LedgerNameList &&
                  res.data.LedgerNameList.length > 0
                ) {
                  rowsPaymentMode = res.data.LedgerNameList;
                  LedgerNameList = res.data.LedgerNameList;
                  rowsCountPaymentMode = rowsPaymentMode.length;
                } /*  else {
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = res.data.LedgerNameList;
                LedgerNameList = res.data.LedgerNameList;
              }
            } */
                if (res.data.PaymentData && res.data.PaymentData.length > 0) {
                  res.data.PaymentData.map((odd) => {
                    let isFound = 0;
                    rowsPaymentMode.map((rod) => {
                      if (rod.vac_ledgername === odd.vac_ledgername) {
                        // rod.vac_value = odd.vac_value;
                        rod.dec_amount = odd.dec_amount;
                        rod.vac_chequeno = odd.vac_chequeno;
                        rod.vac_referenceno = odd.vac_referenceno;
                        rod.dat_transactiondate = odd.dat_transactiondate;
                        rod.vac_remark = odd.vac_remark;
                        rod.vac_groupname = odd.vac_groupname;
                        isFound++;
                      }
                    });
                    if (isFound === 0) {
                      rowsPaymentMode.push({
                        vac_ledgername: odd.vac_ledgername,
                        dec_amount: odd.dec_amount,
                        vac_chequeno: odd.vac_chequeno,
                        vac_referenceno: odd.vac_referenceno,
                        dat_transactiondate: odd.dat_transactiondate,
                        vac_remark: odd.vac_remark,
                        vac_groupname: odd.vac_groupname,
                        // bint_displayorderno: rowsPaymentMode.length + 1,
                      });
                    }
                  });
                  rowsCountPaymentMode = rowsPaymentMode.length;
                }
                if (res.data.DetailList && res.data.DetailList.length > 0) {
                  res.data.DetailList.map((row) => {
                    rowsOtherDetail.push({
                      ...row,
                      txtFormate:
                        row["vac_calculationstyle"] == "Before Tax"
                          ? row["vac_calculation"] +
                            (row["vac_taxname"]
                              ? "(" + row["vac_taxname"] + ")"
                              : "")
                          : row["vac_calculation"],
                      inputColumnName: "vac_value",
                    });
                    rowsOtherDetail1.push({
                      ...row,
                      txtFormate:
                        row["vac_calculationstyle"] == "Before Tax"
                          ? row["vac_calculation"] +
                            (row["vac_taxname"]
                              ? "(" + row["vac_taxname"] + ")"
                              : "")
                          : row["vac_calculation"],
                      inputColumnName: "vac_value",
                    });
                  });
                  DetailList = res.data.DetailList;
                  rowsCountOtherDetail = rowsOtherDetail.length;
                  rowsCountOtherDetail1 = rowsOtherDetail1.length;
                }
                // if (res.data.DetailList && res.data.DetailList.length > 0) {
                //   rowsOtherDetail1 = res.data.DetailList.map((row) => {
                //     return {
                //       ...row,
                //       txtFormate:
                //         row["vac_calculationstyle"] == "Before Tax"
                //           ? row["vac_calculation"] +
                //             (row["vac_taxname"]
                //               ? "(" + row["vac_taxname"] + ")"
                //               : "")
                //           : row["vac_calculation"],
                //       inputColumnName: "vac_value",
                //     };
                //   });
                //   DetailList = res.data.DetailList;
                //   rowsCountOtherDetail1 = rowsOtherDetail1.length;
                // }
                if (
                  res.data.OtherDetailData &&
                  res.data.OtherDetailData.length > 0
                ) {
                  // console.log(
                  //   "res.data.OtherDetailData",
                  //   res.data.OtherDetailData
                  // );
                  res.data.OtherDetailData.map((odd) => {
                    let isFound = 0;
                    let isFound1 = 0;

                    rowsOtherDetail.map((rod) => {
                      if (rod.vac_headingvalue === odd.vac_headingvalue) {
                        rod.vac_value = odd.vac_value;
                        isFound++;
                      }
                    });

                    rowsOtherDetail1.map((rod) => {
                      if (rod.vac_headingvalue === odd.vac_headingvalue) {
                        rod.vac_value = odd.vac_value;
                        isFound1++;
                      }
                    });

                    if (isFound === 0) {
                      rowsOtherDetail.push({
                        vac_headingvalue: odd.vac_headingvalue,
                        vac_value: odd.vac_value,
                        bint_displayorderno: rowsOtherDetail.length + 1,
                      });
                    }

                    if (isFound1 === 0) {
                      rowsOtherDetail1.push({
                        vac_headingvalue: odd.vac_headingvalue,
                        vac_value: odd.vac_value,
                        bint_displayorderno: rowsOtherDetail1.length + 1,
                      });
                    }
                  });
                  rowsCountOtherDetail = rowsOtherDetail.length;
                  rowsCountOtherDetail1 = rowsOtherDetail1.length;
                }
                // if (
                //   res.data.OtherDetailData &&
                //   res.data.OtherDetailData.length > 0
                // ) {
                //   res.data.OtherDetailData.map((odd) => {
                //     let isFound = 0;
                //     rowsOtherDetail1.map((rod) => {
                //       if (rod.vac_headingvalue === odd.vac_headingvalue) {
                //         rod.vac_value = odd.vac_value;
                //         isFound++;
                //       }
                //     });
                //     if (isFound === 0) {
                //       rowsOtherDetail1.push({
                //         vac_headingvalue: odd.vac_headingvalue,
                //         vac_value: odd.vac_value,
                //         bint_displayorderno: rowsOtherDetail1.length + 1,
                //       });
                //     }
                //   });
                //   rowsCountOtherDetail1 = rowsOtherDetail1.length;
                // }
                if (res.data.PaymentData && res.data.PaymentData.length > 0) {
                  PaymentData = res.data.PaymentData;
                  ispaid = false;
                } else {
                  ispaid = true;
                }
                if (res.data.OrderSelection === "true") {
                  this.setState({ Displaybtn: true });
                }

                let subSupplyType = InvoiceNoList.find(
                  (row) =>
                    row.vac_invoicetype === res.data.SalesList[0].vac_billtype,
                )?.vac_ewaybillsubtype;
                if (res.data.SalesInvoiceDefault_Print?.length > 0) {
                  SalesInvoiceDefault_Print =
                    res.data.SalesInvoiceDefault_Print[0].vac_value;
                }
                res.data.InvoiceNoList.map((row) => {
                  let SalesInvoiceDefaultPrint = row.vac_invoicepaper;
                });
                // console.log("rowsPaymentMode 2152", rowsPaymentMode);

                this.setState(
                  {
                    SalesInvoiceDefault_Print,
                    SalesInvoiceDefaultPrint,
                    ispaid,
                    dataLoadStatus: true,
                    Customer,
                    CompanyList,
                    ShipTo,
                    TaxNameList,
                    ItemNameList,
                    BillNoList: InvoiceNoList,
                    DefaultEntrySettingList,
                    StoreList,
                    SalesInvoiceGeneration,
                    SalesInvoiceDefaultPrint,
                    rows,
                    IntSignature_StampPrint,
                    rowsCount,
                    rowsOtherDetail,
                    rowsOtherDetail1,

                    rowsCountOtherDetail,
                    rowsCountOtherDetail1,

                    rowsPaymentMode,
                    rowsCountPaymentMode,
                    LedgerNameList,
                    DetailList,
                    ReferenceList,
                    PaymentData,
                    totalAfterTaxAmt: res.data.SalesList[0].dec_aftertaxamt,
                    totalBeforeTaxAmt: res.data.SalesList[0].dec_beforetaxamt,
                    totalafterDeductionTaxamt:
                      res.data.SalesList[0].totalafterDeductionTaxamt,
                    totalAfteraddTaxamt:
                      res.data.SalesList[0].totalAfteraddTaxamt,
                    totalBeforeaddTaxamt:
                      res.data.SalesList[0].totalBeforeaddTaxamt,
                    totalBeforeDeductionTaxamt:
                      res.data.SalesList[0].totalBeforeDeductionTaxamt,
                    EWayBillData,
                    StateList,
                    formData: {
                      ...this.state.formData,
                      edit_salessrno: res.data.SalesList[0].bint_salessrno,
                      dtpDate: res.data.SalesList[0].dat_salesdate,
                      subSupplyType,
                      // dtpDueDate: res.data.SalesList[0].dtpDueDate,
                      cmbCompany: res.data.SalesList[0].vac_company,
                      cmbBillType: res.data.SalesList[0].vac_billtype,
                      txtBillNo: res.data.SalesList[0].bint_billno,
                      LblBillNo: res.data.SalesList[0].vac_billno,
                      cmbCustomer: res.data.SalesList[0].vac_customer,
                      cmbShipTo: getString_or_Blank4Null(
                        res.data.SalesList[0].vac_customershipto,
                      ),
                      cmbReference: res.data.SalesList[0].vac_referencename,
                      txtbasicamt: res.data.SalesList[0].dec_basicamt,
                      txtDiscount: res.data.SalesList[0].dec_discamt,
                      txtTaxable: res.data.SalesList[0].dec_taxable,
                      txtCGST: res.data.SalesList[0].dec_cgst,
                      txtSGST: res.data.SalesList[0].dec_sgst,
                      txtIGST: res.data.SalesList[0].dec_igst,
                      txtGrandTotal: res.data.SalesList[0].dec_grtotal,
                      txtTDSAmount: res.data.SalesList[0].dec_tdsamount,
                      txtAdvPayment: res.data.SalesList[0].dec_advancepayment,
                      txtRoundOff: res.data.SalesList[0].dec_roundoff,
                      txtNetPayment: res.data.SalesList[0].dec_netpayment,
                      dec_remainamt: res.data.SalesList[0].dec_remainamt,
                      cmbTransactionType:
                        res.data.SalesList[0].vac_salestransactiontype,
                      txtRemark: res.data.SalesList[0].vac_remark,
                      chkReceiptGenerated:
                        res.data.SalesList[0].vac_receiptgenerated == "Yes"
                          ? true
                          : false,
                      txtACKDate: res.data.SalesList[0].dat_ackdate,
                      txtACKno: res.data.SalesList[0].vac_ackno,
                      txtIRN: res.data.SalesList[0].vac_irn,
                    },
                  },
                  () => {
                    if (this.state.formData.cmbTransactionType === "Remain") {
                      this.setState({
                        ispaid: false,
                      });
                    }
                    // console.log(
                    //   "res.data.SalesList[0].vac_referencename",
                    //   res.data.SalesList[0].vac_referencename
                    // );

                    if (
                      this.state.formData.cmbTransactionType === "Paid" &&
                      !this.state.isEditMode &&
                      !this.state.hasOpenedTransactionType
                    ) {
                      this.setState({ hasOpenedTransactionType: false });
                    } else if (
                      this.state.formData.cmbTransactionType === "Remain"
                    ) {
                      this.setState({
                        isEditMode: false,
                        isInitialLoad: false,
                      });
                    }
                  },
                );
              } else {
                this.loadData();
              }
            })
            .catch((error) => {
              this.props.toastMsg(
                "error",
                "Unkonwn Error occured in onFormLoad. " + error,
              );
            });
          this.getStateCodeOFCustomer();
        } else {
          this.loadData();
        }
      },
    );
    document.getElementById("cmbCustomer").focus();
  };
  loadData = () => {
    const reqData = {
      Op: "LoadSalesAllCmbDetail",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      vac_userid: localStorage.getItem("logInID"),
    };
    fetchSales(reqData)
      .then((res) => {
        let dataLoadStatus = true;
        this.setState({ isEditMode: false, isInitialLoad: false });
        let CompanyList = [],
          Customer = [],
          ShipTo = [],
          TaxNameList = [],
          ItemNameList = [],
          StoreList = [],
          SalesInvoiceGeneration = [],
          InvoiceNoList = [],
          DefaultEntrySettingList = [],
          cmbTransactionType = "",
          SalesInvoiceDefaultPrint = "",
          IntSignature_StampPrint = 0,
          rowsOtherDetail = [],
          rowsOtherDetail1 = [],
          rowsCountOtherDetail = rowsOtherDetail.length,
          rowsCountOtherDetail1 = rowsOtherDetail1.length,
          rowsPaymentMode = [],
          rowsCountPaymentMode = rowsPaymentMode.length,
          LedgerNameList = [],
          DetailList = [],
          PaymentData = [],
          // columnsOtherDetail = [],
          ReferenceList = [];

        let StrSignature_StampPrint = getRowData(
          res.data.GeneralSettingList,
          "vac_key",
          "In Sales (Default)",
        );
        res.data.GeneralSettingList.map((row) => {
          if (row.vac_module === "Sales") {
            if (row.vac_key === "Sales Invoice Generation") {
              SalesInvoiceGeneration = row.vac_value;
            }
            if (row.vac_key === "Sales Invoice Default Print") {
              SalesInvoiceDefaultPrint = row.vac_value;
            }
          }
          if (row.vac_module === "Signature & Stamp") {
            if (row.vac_key === "In Sales (Default)") {
              IntSignature_StampPrint =
                StrSignature_StampPrint["vac_value"] === "Yes" ? 1 : 0;
            }
          }
        });
        if (res.data.CustomerList && res.data.CustomerList.length > 0) {
          Customer = res.data.CustomerList;
        }

        // console.log("res.data.CompanyList", res.data.CompanyList);

        if (res.data.CompanyList && res.data.CompanyList.length > 0) {
          CompanyList = res.data.CompanyList;
        }
        if (res.data.CustomerList && res.data.CustomerList.length > 0) {
          ShipTo = res.data.CustomerList;
        }
        if (res.data.TaxList && res.data.TaxList.length > 0) {
          TaxNameList = res.data.TaxList;
        }
        if (res.data.ItemList && res.data.ItemList.length > 0) {
          ItemNameList = res.data.ItemList;
        }
        if (res.data.StoreList && res.data.StoreList.length > 0) {
          StoreList = res.data.StoreList;
        }
        // if (
        //   res.data.GeneralSettingList &&
        //   res.data.GeneralSettingList.length > 0
        // ) {
        //   // SalesInvoiceGeneration = res.data.GeneralSettingList[0].vac_value;
        //   res.data.GeneralSettingList.map((row) => {
        //     if (row.vac_module === "Sales") {
        //       if (row.vac_key === "Sales Invoice Generation") {
        //         SalesInvoiceGeneration = row.vac_value;
        //       }
        //     }
        //   });
        // }
        if (res.data.InvoiceNoList && res.data.InvoiceNoList.length > 0) {
          InvoiceNoList = res.data.InvoiceNoList;
        }
        if (
          res.data.DefaultEntrySettingList &&
          res.data.DefaultEntrySettingList.length > 0
        ) {
          DefaultEntrySettingList = res.data.DefaultEntrySettingList;
        }
        if (DefaultEntrySettingList.length > 0) {
          cmbTransactionType = DefaultEntrySettingList[0].vac_transacationtype;
        }
        if (res.data.LedgerNameList && res.data.LedgerNameList.length > 0) {
          rowsPaymentMode = res.data.LedgerNameList;
          LedgerNameList = res.data.LedgerNameList;
          rowsCountPaymentMode = rowsPaymentMode.length;
        }
        // if (res.data.DetailList && res.data.DetailList.length > 0) {
        //   rowsOtherDetail = res.data.DetailList.map((row, index) => {
        //     return {
        //       ...row,
        //       txtFormate:
        //         row["vac_calculationstyle"] == "Before Tax"
        //           ? row["vac_calculation"] +
        //             (row["vac_taxname"] ? "(" + row["vac_taxname"] + ")" : "")
        //           : row["vac_calculation"],
        //       inputColumnName: "vac_value",
        //     };
        //   });
        //   DetailList = res.data.DetailList;
        //   rowsCountOtherDetail = rowsOtherDetail.length;
        // }
        // if (res.data.DetailList && res.data.DetailList.length > 0) {
        //   rowsOtherDetail1 = res.data.DetailList.map((row) => {
        //     return {
        //       ...row,
        //       txtFormate:
        //         row["vac_calculationstyle"] == "Before Tax"
        //           ? row["vac_calculation"] +
        //             (row["vac_taxname"] ? "(" + row["vac_taxname"] + ")" : "")
        //           : row["vac_calculation"],
        //       inputColumnName: "vac_value",
        //     };
        //   });
        //   DetailList = res.data.DetailList;
        //   rowsCountOtherDetail1 = rowsOtherDetail1.length;
        // }
        if (res.data.DetailList && res.data.DetailList.length > 0) {
          res.data.DetailList.map((row) => {
            rowsOtherDetail.push({
              ...row,
              txtFormate:
                row["vac_calculationstyle"] == "Before Tax"
                  ? row["vac_calculation"] +
                    (row["vac_taxname"] ? "(" + row["vac_taxname"] + ")" : "")
                  : row["vac_calculation"],
              inputColumnName: "vac_value",
            });
            rowsOtherDetail1.push({
              ...row,
              txtFormate:
                row["vac_calculationstyle"] == "Before Tax"
                  ? row["vac_calculation"] +
                    (row["vac_taxname"] ? "(" + row["vac_taxname"] + ")" : "")
                  : row["vac_calculation"],
              inputColumnName: "vac_value",
            });
          });
          DetailList = res.data.DetailList;
          rowsCountOtherDetail = rowsOtherDetail.length;
          rowsCountOtherDetail1 = rowsOtherDetail1.length;
        }
        if (res.data.ReferenceList && res.data.ReferenceList.length > 0) {
          ReferenceList = res.data.ReferenceList;
        }
        if (res.data.PaymentData && res.data.PaymentData.length > 0) {
          PaymentData = res.data.PaymentData;
        }
        if (res.data.OrderSelection === "true") {
          this.setState({ Displaybtn: true });
        }
        this.setState(
          {
            dataLoadStatus,
            Customer,
            CompanyList,
            ShipTo,
            TaxNameList,
            ItemNameList,
            // columnsOtherDetail,
            StoreList,
            SalesInvoiceGeneration,
            SalesInvoiceDefaultPrint,
            IntSignature_StampPrint,
            BillNoList: InvoiceNoList,
            DefaultEntrySettingList,
            LedgerNameList,
            DetailList,
            PaymentData,
            formData: {
              ...this.state.formData,
              cmbTransactionType,
            },
            autoResetFormData: true,
            rowsOtherDetail,
            rowsOtherDetail1,

            rowsCountOtherDetail: rowsOtherDetail.length,
            rowsCountOtherDetail1: rowsOtherDetail1.length,

            rowsPaymentMode,
            rowsCountPaymentMode,
            ReferenceList,
          },
          () => {
            this.getDefaultBillType();
          },
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    this.getStateCodeOFCustomer();
  };

  clearInfo = () => {
    let cmbTransactionType = "";
    if (
      this.state.DefaultEntrySettingList &&
      this.state.DefaultEntrySettingList.length > 0
    ) {
      cmbTransactionType =
        this.state.DefaultEntrySettingList[0].vac_transacationtype;
    }
    let rowsOtherDetails = this.state.rowsOtherDetail.map((row) => {
      return {
        ...row,
        vac_value: "",
      };
    });
    let rowsOtherDetail1 = this.state.rowsOtherDetail1.map((row) => {
      return {
        ...row,
        vac_value: "",
      };
    });
    this.setState(
      {
        totalAfterTaxAmt: 0,
        totalafterDeductionTaxamt: 0,
        totalAfteraddTaxamt: 0,
        totalBeforeaddTaxamt: 0,
        totalBeforeDeductionTaxamt: 0,
        totalBeforeTaxAmt: 0,
        formData: {
          ...this.state.formData,
          edit_salessrno: "",
          dtpDate: get_YMD_from_SYS(new Date()),
          dtpDueDate: "",
          cmbCompany: localStorage.getItem("CompanyName"),
          // cmbBillType: "",
          // txtBillNo: "",
          // LblBillNo: "",
          cmbCustomer: "",
          cmbShipTo: "",
          txtOtherDetail: "",
          txtbasicamt: 0,
          txtDiscount: 0,
          txtTaxable: 0,
          txtCGST: "",
          txtSGST: "",
          txtIGST: "",
          tblCGST: "",
          tblSGST: "",
          tblIGST: "",
          txtGrandTotal: "",
          txtTDSAmount: "",
          txtAdvPayment: "",
          txtNetPayment: "",
          txtRoundOff: "",
          cmbTransactionType,
          txtRemark: "",
          chkReceiptGenerated: false,
          cmbReference: "",
          txtACKDate: "",
          txtACKno: "",
          txtIRN: "",
        },
        rows: [],
        rowsCount: 0,
        rowsOtherDetail: rowsOtherDetails,
        rowsOtherDetail1: rowsOtherDetail1,

        rowsCountOtherDetail: this.state.rowsOtherDetail.length,
        rowsCountOtherDetail1: this.state.rowsOtherDetail1.length,

        rowsPaymentMode: copyRowsAllCols(
          this.state.LedgerNameList,
          this.state.PaymentmodeListCols,
        ),
        rowsCountPaymentMode: this.state.LedgerNameList.length,
        PaymentData: [],
      },
      () => {
        this.getDefaultBillType();
        document.getElementById("dtpDate").focus();
        // this.props.navigateTo("Salesnew");
      },
    );
  };

  updateStateInfo = (rows) => {
    let count = 0;
    rows.map((row) => {
      if (count === 0) {
        count++;
        this.setState({
          ARD: null,
          rows,
          rowsCount: rows.length,
          OrderselectionVisible: true,
        });
      }
    });
  };

  addActionColStatus = (rows) => {
    // console.log("rows disable edit", rows);
    const newRows = rows.map((row) => {
      const actionStatus = row.vac_orderitemno.length > 0 ? true : false;
      // console.log("row.vac_orderitemno", row.vac_orderitemno);
      return {
        ...row,
        DisableEdit: actionStatus,
      };
    });
    return newRows;
  };

  // DisableOnEditDelete = (vac_orderitemno) => {
  //   let DisableEdit = false;
  //   if (vac_orderitemno.length == 0) {
  //     DisableEdit = false;
  //   } else {
  //     DisableEdit = true;
  //   }
  //   return DisableEdit;
  // };

  OrderSelection = () => {
    if (this.validateSales() === true) {
      // this.getLedgerName = () => {
      //   if (this.state.LedgerNameList && this.state.LedgerNameList[0]) {
      //     return this.state.LedgerNameList[0].vac_ledgername;
      //   } else {
      //     return "";
      //   }
      // };
      let ARD = null;
      this.setState({ ARD }, () => {
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            maxWidthClass={"1000px"}
            // alertTitle={'Sales Item Entry'}
            alertMessage={
              <OrderSelection
                SelectionFrom="Sales"
                Customer={this.state.formData.cmbCustomer}
                DRPname={
                  this.state.LedgerNameList && this.state.LedgerNameList[0]
                    ? this.state.LedgerNameList[0].vac_ledgername
                    : ""
                }
                bint_acyear={localStorage.getItem("ACY")}
                bint_acid={localStorage.getItem("acid")}
                cmbCompany={localStorage.getItem("CompanyName")}
                bint_salessrno={this.state.formData.edit_salessrno}
                dtpDate={this.state.formData.dtpDate}
                cmbBillType={this.state.formData.cmbBillType}
                txtBillNo={this.state.formData.LblBillNo}
                bint_billno={this.state.formData.txtBillNo}
                cmbCustomer={this.state.formData.cmbCustomer}
                cmbShipTo={this.state.formData.cmbShipTo}
                cmbReference={this.state.formData.cmbReference}
                // CustomerStateCode={this.state.CustomerStateCode}
                // txtOtherDetail={this.state.formData.txtOtherDetail}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtTDSAmount={this.state.formData.txtTDSAmount}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                txtNetPayment={this.state.formData.txtNetPayment}
                cmbTransactionType={this.state.formData.cmbTransactionType}
                txtRemark={this.state.formData.txtRemark}
                vac_receiptgenerated={
                  this.state.formData.chkReceiptGenerated ? "Yes" : "No"
                }
                vac_referencename={this.state.formData.cmbReference}
                bint_ci={localStorage.getItem("CI")}
                vac_username={localStorage.getItem("UserName")}
                onSuccessfulSelsSelection={this.updateStateInfo}
                refreshSalesItemList={this.refreshSalesItemList}
                resetAmount={this.resetAmount}
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  saveSales = (
    bolinvoiceprint,
    copyInvoiceDetailsToClipBoard,
    bolewaybillprocess,
  ) => {
    if (
      this.validateSales() &&
      this.validateSalesItemCount() &&
      this.validatePaymentModeAmount()
    ) {
      // this.props.toastErrorMsg("Second Alert")
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      // this.props.toastErrorMsg("Third Alert");
      // console.log(
      //   "Number(this.state.formData.tblCGST)",
      //   Number(this.state.formData.tblCGST)
      // );
      // console.log(
      //   "this.state.formData.txtCGST + this.state.formData.tblCGST",
      //   Number(this.state.formData.txtCGST) +
      //     Number(this.state.formData.tblCGST)
      // );
      let rowsTotal = getRowColSum(this.state.rows, [
        "dec_cgstamt",
        "dec_sgstamt",
        "dec_igstamt",
      ]);
      /* dec_cgst:
             Number(this.state.formData.txtCGST) +
             Number(this.state.formData.tblCGST),
           dec_sgst:
             Number(this.state.formData.txtSGST) +
             Number(this.state.formData.tblSGST),
           dec_igst:
             Number(this.state.formData.txtIGST) +
             Number(this.state.formData.tblIGST), */

      let rowsOtherDetail = this.state.rowsOtherDetail.filter(
        (row) => row.vac_calculation === "",
      );

      let rowsOtherDetail1 = this.state.rowsOtherDetail1.filter(
        (row) => row.vac_calculation !== "",
      );

      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveSales_Item",
          bint_acyear: localStorage.getItem("ACY"),
          bolinvoiceprint: false,
          bint_acid: localStorage.getItem("acid"),
          vac_company: this.state.formData.cmbCompany,
          bint_salessrno: this.state.formData.edit_salessrno,
          dat_salesdate: this.state.formData.dtpDate,
          vac_billtype: this.state.formData.cmbBillType,
          vac_billno: this.state.formData.LblBillNo,
          bint_billno: this.state.formData.txtBillNo,
          vac_customer: this.state.formData.cmbCustomer,
          vac_customershipto: this.state.formData.cmbShipTo,
          dec_discamt: this.state.formData.txtDiscount,
          dec_taxable: this.state.formData.txtTaxable,
          dec_cgst:
            Number(rowsTotal.dec_cgstamt) + Number(this.state.formData.tblCGST),
          dec_sgst:
            Number(rowsTotal.dec_sgstamt) + Number(this.state.formData.tblSGST),
          dec_igst:
            Number(rowsTotal.dec_igstamt) + Number(this.state.formData.tblIGST),
          dec_grtotal: this.state.formData.txtGrandTotal,
          dec_tdsamount: this.state.formData.txtTDSAmount,
          dec_advancepayment: this.state.formData.txtAdvPayment,
          dec_roundoff: this.state.formData.txtRoundOff,
          dec_netpayment: this.state.formData.txtNetPayment,
          vac_salestransactiontype: this.state.formData.cmbTransactionType,
          bint_vouno: 0,
          vac_remark: this.state.formData.txtRemark,
          vac_receiptgenerated: this.state.formData.chkReceiptGenerated
            ? "Yes"
            : "No",
          PaymentData: this.getPaymentModeDataStatus()
            ? this.state.rowsPaymentMode
            : [],
          OtherDetailData: [...rowsOtherDetail, ...rowsOtherDetail1],
          bint_ci: localStorage.getItem("CI"),
          vac_username: localStorage.getItem("UserName"),
          vac_referencename: this.state.formData.cmbReference,
          dec_beforetaxamt: this.state.totalBeforeTaxAmt,
          dec_aftertaxamt: this.state.totalAfterTaxAmt,
          dec_basicamt: this.state.formData.txtbasicamt,
          totalafterDeductionTaxamt: this.state.totalafterDeductionTaxamt,
          totalAfteraddTaxamt: this.state.totalAfteraddTaxamt,
          totalBeforeaddTaxamt: this.state.totalBeforeaddTaxamt,
          totalBeforeDeductionTaxamt: this.state.totalBeforeDeductionTaxamt,
        };
        fetchSales(reqData)
          .then((res) => {
            // console.log("reqData", reqData);
            this.props.updateProcessing(res.data.msgType, res.data.message);
            // console.log("res.data.msgType", res.data.msgType);
            if (res.data.msgType === "success") {
              let DefaultEntrySettingList = res.data.DefaultEntrySettingList,
                cmbTransactionType = "",
                rowsOtherDetail = [],
                rowsCountOtherDetail = rowsOtherDetail.length,
                rowsOtherDetail1 = [],
                rowsCountOtherDetail1 = rowsOtherDetail1.length,
                rowsPaymentMode = [],
                DetailList = [],
                rowsCountPaymentMode = rowsPaymentMode.length,
                InvoiceNoList = res.data.InvoiceNoList;
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = res.data.LedgerNameList;
                rowsCountPaymentMode = rowsPaymentMode.length;
              }
              // if (res.data.DetailList && res.data.DetailList.length > 0) {
              //   rowsOtherDetail = res.data.DetailList;
              //   rowsCountOtherDetail = rowsOtherDetail.length;

              // }
              // if (res.data.DetailList && res.data.DetailList.length > 0) {
              //   rowsOtherDetail = res.data.DetailList.map((row, index) => {
              //     return {
              //       ...row,
              //       txtFormate:
              //         row["vac_calculationstyle"] == "Before Tax"
              //           ? row["vac_calculation"] +
              //             (row["vac_taxname"]
              //               ? "(" + row["vac_taxname"] + ")"
              //               : "")
              //           : row["vac_calculation"],
              //       inputColumnName: "vac_value",
              //     };
              //   });
              //   DetailList = res.data.DetailList;
              //   rowsCountOtherDetail = rowsOtherDetail.length;
              // }
              // if (res.data.DetailList && res.data.DetailList.length > 0) {
              //   rowsOtherDetail1 = res.data.DetailList.map((row) => {
              //     return {
              //       ...row,
              //       txtFormate:
              //         row["vac_calculationstyle"] == "Before Tax"
              //           ? row["vac_calculation"] +
              //             (row["vac_taxname"]
              //               ? "(" + row["vac_taxname"] + ")"
              //               : "")
              //           : row["vac_calculation"],
              //       inputColumnName: "vac_value",
              //     };
              //   });
              //   DetailList = res.data.DetailList;
              //   rowsCountOtherDetail1 = rowsOtherDetail1.length;
              // }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                res.data.DetailList.map((row) => {
                  rowsOtherDetail.push({
                    ...row,
                    txtFormate:
                      row["vac_calculationstyle"] == "Before Tax"
                        ? row["vac_calculation"] +
                          (row["vac_taxname"]
                            ? "(" + row["vac_taxname"] + ")"
                            : "")
                        : row["vac_calculation"],
                    inputColumnName: "vac_value",
                  });
                  rowsOtherDetail1.push({
                    ...row,
                    txtFormate:
                      row["vac_calculationstyle"] == "Before Tax"
                        ? row["vac_calculation"] +
                          (row["vac_taxname"]
                            ? "(" + row["vac_taxname"] + ")"
                            : "")
                        : row["vac_calculation"],
                    inputColumnName: "vac_value",
                  });
                });
                DetailList = res.data.DetailList;
                rowsCountOtherDetail = rowsOtherDetail.length;
                rowsCountOtherDetail1 = rowsOtherDetail1.length;
              }
              if (DefaultEntrySettingList.length > 0) {
                cmbTransactionType =
                  DefaultEntrySettingList[0].vac_transacationtype;
              }
              this.setState(
                {
                  dataLoadStatus: true,
                  BillNoList: InvoiceNoList,
                  DefaultEntrySettingList,
                  formData: {
                    ...this.state.formData,
                    cmbTransactionType,
                  },
                  rowsOtherDetail,
                  rowsCountOtherDetail,
                  rowsOtherDetail1,
                  rowsCountOtherDetail1,
                  rowsPaymentMode,
                  rowsCountPaymentMode,
                },
                () => {
                  if (bolinvoiceprint) {
                    this.openInvoiceARDSelection();
                  }
                  /** Call copyInvoiceDetailsToClipBoard */
                  if (copyInvoiceDetailsToClipBoard) {
                    copyInvoiceDetailsToClipBoard();
                  }
                  if (bolewaybillprocess) {
                    this.ewaybillprocess();
                  }
                  this.clearInfo();
                },
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in saveSales.", error);
          });
      });
    }
  };

  onDeleteBtnClick = () => {
    if (this.state.formData.edit_salessrno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Bill No. : " +
              this.state.formData.LblBillNo +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteSales(this.state.formData.edit_salessrno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("There are no sales to delete", "dtpDate");
    }
  };

  deleteSales = (edit_salessrno) => {
    if (edit_salessrno > 0) {
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "DeleteSales",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          edit_salessrno: edit_salessrno,
          dat_fromdate: "",
          dat_todate: "",
        };
        fetchSales(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.setState({ ARD: null, dataLoadStatus: true }, () => {
                this.clearInfo();
              });
            } else {
              this.setState({ dataLoadStatus: true });
            }
          })
          .catch((error) => {
            this.props.updateProcessing(
              "error",
              "Unknown error occurred in delete deleteSales. " + error,
            );
          });
      });
    } else {
      this.props.notifyProcessing();
      this.props.updateProcessing(
        "error",
        "There are no sales records to delete.",
      );
    }
  };

  deleteSalesItem = (bint_acyear, bint_acid, bint_salessrno, bint_itemsrno) => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeleteSalesItem",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_salessrno: bint_salessrno,
        edit_itemsrno: bint_itemsrno,
        dec_tdsamount: this.state.formData.txtTDSAmount,
        dec_advancepayment: this.state.formData.txtAdvPayment,
        vac_customer: this.state.formData.cmbCustomer,
        bint_ci: localStorage.getItem("CI"),
        vac_username: localStorage.getItem("UserName"),
        dat_salesdate: this.state.formData.dtpDate,
        vac_remark: this.state.formData.txtRemark,
        vac_salestransactiontype: this.state.formData.cmbTransactionType,
        PaymentData: this.state.rowsPaymentMode,
        dec_roundoff: this.state.formData.txtRoundOff,
        vac_billno: this.state.formData.txtBillNo,
        dec_netpayment: this.state.formData.txtNetPayment,
        vac_receiptgenerated: this.state.formData.chkReceiptGenerated
          ? "Yes"
          : "No",
      };
      fetchSales(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          let dec_basicamt = 0,
            dec_disamt = 0,
            dec_taxable = 0,
            dec_cgstamt = 0,
            dec_sgstamt = 0,
            dec_igstamt = 0,
            dec_totalamt = 0,
            SalesItemData = [];
          if (res.data.SalesItemData && res.data.SalesItemData.length > 0) {
            rows = this.addActionColStatus(res.data.SalesItemData);
            rowsCount = rows.length;
          }
          if (res.data.TotalItemAmountData) {
            dec_basicamt = Number(res.data.TotalItemAmountData[0].dec_basicamt);
            dec_disamt = Number(res.data.TotalItemAmountData[0].dec_disamt);
            dec_taxable = Number(res.data.TotalItemAmountData[0].dec_taxable);
            dec_cgstamt = Number(res.data.TotalItemAmountData[0].dec_cgstamt);
            dec_sgstamt = Number(res.data.TotalItemAmountData[0].dec_sgstamt);
            dec_igstamt = Number(res.data.TotalItemAmountData[0].dec_igstamt);
            dec_totalamt = Number(res.data.TotalItemAmountData[0].dec_totalamt);
          }
          this.resetAmount(
            dec_basicamt,
            dec_taxable,
            dec_cgstamt,
            dec_sgstamt,
            dec_igstamt,
            dec_totalamt,
            dec_disamt,
            bint_salessrno,
          );
          this.setState({
            ARD: null,
            rows,
            rowsCount,
            dataLoadStatus,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in deleteSalesList.", error);
        });
    });
    return true;
  };

  refreshSalesItemList = (
    rows,
    rowsCount,
    rowsOtherDetail = this.state.rowsOtherDetail,
    rowsOtherDetail1 = this.state.rowsOtherDetail1,
    rowsCountOtherDetail = this.state.rowsCountOtherDetail,
    rowsCountOtherDetail1 = this.state.rowsCountOtherDetail1,
  ) => {
    rows = this.addActionColStatus(rows);
    // console.log("rows", rows);
    this.setState(
      {
        rows,
        rowsCount,
        rowsOtherDetail,
        rowsOtherDetail1,
        rowsCountOtherDetail,
        rowsCountOtherDetail1,
      },
      () => {},
    );
  };

  resetAmount = (
    txtbasicamt,
    txtTaxable,
    txtCGST,
    txtSGST,
    txtIGST,
    txtGrandTotal,
    txtDiscount,
    edit_salessrno,
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtbasicamt: txtbasicamt.toFixed(2),
          txtTaxable: txtTaxable.toFixed(2),
          txtCGST,
          txtSGST,
          txtIGST,
          txtGrandTotal,
          txtDiscount: txtDiscount.toFixed(2),
          edit_salessrno,
        },
      },
      () => {
        // console.log("edit_salessrno", edit_salessrno);
        // this.calNetAmount();
      },
    );
  };

  // calNetAmount = () => {
  //   console.log("call");

  //   let txtNetPayment =
  //       Number(this.state.formData.txtGrandTotal) -
  //       Number(this.state.formData.txtTDSAmount) -
  //       Number(this.state.formData.txtAdvPayment) +
  //       Number(this.state.formData.txtRoundOff),
  //     txtRoundOff = 0;

  //   let arrNetPayment = getRoundOff(txtNetPayment);
  //   txtNetPayment = arrNetPayment["roff_number"];
  //   txtRoundOff = arrNetPayment["roff"].toFixed(2);
  //   let chkReceiptGenerated = this.state.formData.chkReceiptGenerated;
  //   if (Number(this.state.formData.txtAdvPayment) === Number(0)) {
  //     chkReceiptGenerated = false;
  //   }
  //   this.setState(
  //     {
  //       formData: {
  //         ...this.state.formData,
  //         txtNetPayment,
  //         txtRoundOff,
  //         chkReceiptGenerated,
  //       },
  //     },
  //     () => {}
  //   );
  //   // this.setState(
  //   //   (prevState) => {
  //   //     const targetLedgerNames = prevState.DefaultEntrySettingList.map(
  //   //       (row) => row.vac_ledgername
  //   //     ).filter(Boolean);

  //   //     const updatedRowsPaymentMode = prevState.rowsPaymentMode.map((row) => {
  //   //       if (targetLedgerNames.includes(row.vac_ledgername)) {
  //   //         return {
  //   //           ...row,
  //   //           dec_amount: parseFloat(txtNetPayment),
  //   //           chk_paymentmode: true,
  //   //         };
  //   //       }
  //   //       return row;
  //   //     });

  //   //     return {
  //   //       formData: {
  //   //         ...this.state.formData,
  //   //         txtNetPayment,
  //   //         txtRoundOff,
  //   //         chkReceiptGenerated,
  //   //       },
  //   //       rowsPaymentMode: updatedRowsPaymentMode,
  //   //     };
  //   //   },
  //   //   () => {
  //   //     console.log("Updated payment modes:", this.state.rowsPaymentMode);
  //   //   }
  //   // );
  // };

  generateBillNo = () => {
    if (
      Number(this.state.formData.txtBillNo) > 0 &&
      this.state.formData.SalesInvoiceGeneration != "Auto"
    ) {
      this.props.notifyProcessing();
      const reqData = {
        Op: "CreateStrBillNoFromType",
        bint_acyear: localStorage.getItem("ACY"),
        bint_acid: localStorage.getItem("acid"),
        int_invoiceno: Number(this.state.formData.txtBillNo),
        vac_billtype: this.state.formData.cmbBillType,
      };
      fetchSales(reqData)
        .then((res) => {
          this.props.updateProcessing("success", "Bill No generated");
          this.setState({
            formData: {
              ...this.state.formData,
              LblBillNo: res.data.InvoiceNo,
            },
          });
        })
        .catch((error) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in generateBillNo. " + error,
          );
        });
    } else {
      this.props.toastErrorMsg("Enter Bill No", "txtBillNo");
    }
  };

  getBillNo = () => {
    if (this.state.formData.cmbBillType.length > 0) {
      // console.log("this.state.BillNoList", this.state.BillNoList);
      this.state.BillNoList.map((row) => {
        if (row.vac_invoicetype === this.state.formData.cmbBillType) {
          // console.log("row.vac_invoicetype", row.vac_invoicetype);
          // console.log("row.int_invoiceno", row.int_invoiceno);
          // console.log("row.vac_invoiceno", row.vac_invoiceno);
          this.setState(
            {
              formData: {
                ...this.state.formData,
                txtBillNo: row.int_invoiceno,
                LblBillNo: row.vac_invoiceno,
              },
            },
            () => {
              // console.log("this.state.formData.txtBillNo", this.state.formData.txtBillNo);
              // console.log("this.state.formData.LblBillNo", this.state.formData.LblBillNo);
            },
          );
        }
      });
    }
  };

  getStateCodeOFCustomer = () => {
    if (
      this.state.formData.cmbCustomer.length > 0 &&
      this.state.autoResetFormData === true
    ) {
      this.state.Customer.map((row) => {
        if (row.vac_customer === this.state.formData.cmbCustomer) {
          this.setState({
            formData: {
              ...this.state.formData,
              cmbReference:
                row.vac_referencename != null
                  ? row.vac_referencename
                  : this.state.formData.cmbReference,
            },
            CustomerStateCode: row.vac_statecode,
            CustomerData: row,
          });
        }
      });
    } else if (this.state.autoResetFormData === false) {
      this.setState({ autoResetFormData: true });
    }
  };

  getDefaultBillType = () => {
    if (this.state.BillNoList && this.state.BillNoList.length > 0) {
      this.state.BillNoList.map((row) => {
        if (row.int_default === 1 || row.int_default === "1") {
          this.setState(
            {
              formData: {
                ...this.state.formData,
                cmbBillType: row.vac_invoicetype,
              },
            },
            () => {
              this.getBillNo();
            },
          );
        }
      });
    }
  };

  getCustomerList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadCustomerDetails",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchCustomerMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Customer List Loaded");
        let Customer = res.data.CustomerList,
          ShipTo = res.data.CustomerList;
        this.setState(
          {
            Customer,
            ShipTo,
          },
          () => {
            // console.log("this.state", this.state);
          },
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getCustomerList.", error);
      });
  };

  getReferenceList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadReference",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchReferenceMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Reference List Loaded");
        let ReferenceList = res.data.ReferenceList;
        this.setState(
          {
            ReferenceList,
          },
          () => {
            // console.log("this.state", this.state);
          },
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getReferenceList.", error);
      });
  };

  getDetailList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DetailList",
      bint_acid: localStorage.getItem("acid"),
      vac_detailtype: "",
    };
    fetchDetailMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Detial List Loaded");
        let rowsOtherDetail = res.data.DetailList,
          rowsOtherDetail1 = res.data.DetailList,
          rowsCountOtherDetail = 0,
          rowsCountOtherDetail1 = 0;

        this.setState(
          {
            rowsOtherDetail,
            rowsOtherDetail1,
            rowsCountOtherDetail,

            rowsCountOtherDetail1,
          },
          () => {
            // console.log("this.state", this.state);
          },
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getDetailList.", error);
      });
  };

  onAddClickCustomer = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<CustomerMaster showHeading={true} />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getCustomerList();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  onAddClickReference = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<ReferenceMaster showHeading={true} />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getReferenceList();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  openInvoiceARDSelection = () => {
    let vac_billno = Array(this.state.formData.LblBillNo);
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={
            <SalesInvoiceSelection
              bint_acid={localStorage.getItem("acid")}
              bint_acyear={localStorage.getItem("ACY")}
              vac_billno={vac_billno}
              IntSignature_StampPrint={this.state.IntSignature_StampPrint}
              SalesInvoiceDefaultPrint={this.state.SalesInvoiceDefaultPrint}
              SalesInvoiceDefault_Print={this.state.SalesInvoiceDefault_Print}
            />
          }
          defaultOpenDialog={true}
        />
      );
      this.setState({ ARD });
    });
  };

  getItemList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ItemList",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchItemMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Item List Loaded");
        let ItemNameList = res.data.ItemList;
        this.setState(
          {
            ItemNameList,
          },
          () => {
            // console.log("this.state", this.state);
          },
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getItemList.", error);
      });
  };

  // getPayRemarkLblVisibleStatus = () => {
  //   return this.state.formData.cmbTransactionType == "Remain" &&
  //     Number(this.state.formData.txtAdvPayment) > 0 &&
  //     this.state.formData.chkReceiptGenerated === false
  //     ? true
  //     : false;
  // };

  getPaymentModeDataStatus = () => {
    let result = false;
    if (this.state.formData.cmbTransactionType == "Paid") {
      result = true;
    } else {
      this.state.rowsPaymentMode.map((row) => {
        // row.vac_ledgername = ''
        row.dec_amount = "";
        row.vac_chequeno = "";
        row.vac_referenceno = "";
        row.dat_transactiondate = "";
        row.vac_remark = "";
      });
    }
    return result;
    /* return this.state.formData.cmbTransactionType == "Paid" ||
      this.getPayRemarkLblVisibleStatus()
      ? true
      : false; */
  };

  setSaveBtnDisplay = () => {
    let isParamFound =
      this.props.params &&
      this.props.params.EditSalesSrNo &&
      this.props.params.EditSalesSrNo.substring(1).length > 0;
    if (isParamFound !== true) {
      isParamFound = false;
    }
    let paramEditSalesSrNo = 0;
    if (isParamFound) {
      var editInfo = this.props.params.EditSalesSrNo.split(":");
      paramEditSalesSrNo = Number(editInfo[2]);
      if (paramEditSalesSrNo <= 0) {
        isParamFound = false;
      }
    }
    // console.log("this.props.userPrivilege.Sales", this.props.userPrivilege.Sales, this.props.userPrivilege.Sales == 'W');
    // console.log("Number(this.state.formData.edit_salessrno)", Number(this.state.formData.edit_salessrno), Number(this.state.formData.edit_salessrno) <= Number(0));
    // console.log("isParamFound", isParamFound, isParamFound === false);
    if (this.props.userPrivilege.Sales == "M") {
      return "block";
    } else if (this.props.userPrivilege.Sales == "R") {
      return "none";
    } else if (
      (this.props.userPrivilege.Sales == "W" &&
        Number(this.state.formData.edit_salessrno) > Number(0) &&
        isParamFound === false) ||
      (this.props.userPrivilege.Sales == "W" &&
        Number(this.state.formData.edit_salessrno) > Number(0) &&
        isParamFound === true &&
        Number(this.state.formData.edit_salessrno) !==
          Number(paramEditSalesSrNo)) ||
      (this.props.userPrivilege.Sales == "W" &&
        Number(this.state.formData.edit_salessrno) <= Number(0))
    ) {
      return "block";
    } else {
      return "none";
    }
  };

  setPaymentData = (rowsPaymentMode) => {
    this.setState(
      {
        rowsPaymentMode,
      },
      () => {
        // console.log("this.state.rows", this.state.rows);
      },
    );
  };

  getDefaultEntrySettingRow = () => {
    let DefaultEntrySettingList = [];
    if (
      this.state.DefaultEntrySettingList &&
      this.state.DefaultEntrySettingList.length > 0
    ) {
      if (
        this.state.DefaultEntrySettingList[0].vac_transacationtype == "Paid"
      ) {
        DefaultEntrySettingList = this.state.DefaultEntrySettingList[0];
      } else {
        if (
          this.state.DefaultEntrySettingList[1].vac_transacationtype == "Paid"
        ) {
          DefaultEntrySettingList = this.state.DefaultEntrySettingList[1];
        }
      }
    }
    return DefaultEntrySettingList;
  };

  handleInvoice = () => {
    // const salesInfo = {
    //   bint_acid: localStorage.getItem("acid"),
    //   bint_acyear: localStorage.getItem("ACY"),
    //   vac_billno: this.state.formData.LblBillNo,
    //   edit_salessrno: this.state.formData.edit_salessrno,
    //   vac_userid: localStorage.getItem("UserID"),
    //   bint_ci: localStorage.getItem("CI"),
    // };

    // const jsonString = JSON.stringify({ salesInfo });
    // console.log("jsonString", jsonString);
    // navigator.clipboard
    //   .writeText('"RTW" ' + jsonString)
    // .then(() => {
    this.trimFormData(() => {
      this.saveSales(false, () => {
        const salesInfo = {
          bint_acid: localStorage.getItem("acid"),
          bint_acyear: localStorage.getItem("ACY"),
          vac_billno: this.state.formData.LblBillNo,
          edit_salessrno: this.state.formData.edit_salessrno,
          vac_userid: localStorage.getItem("logInID"),
          bint_ci: localStorage.getItem("CI"),
        };

        const jsonString = JSON.stringify({ salesInfo });
        // console.log("jsonString", jsonString);
        navigator.clipboard.writeText('"RTW" ' + jsonString);
      });
    });
    // })
    // .catch((error) => {
    //   console.error("Error copying to clipboard:", error);
    // });
  };
  // getPaymentModeDataStatus = () => {
  //   let result = false;
  //   if (
  //     this.state.formData.cmbTransactionType == "Paid"
  //     // this.getPayRemarkLblVisibleStatus()
  //   ) {
  //     /*  if (
  //       this.state.formData.cmbTransactionType == " Advance"
  //       // this.getPayRemarkLblVisibleStatus()
  //     )  */ result = true;
  //   } else {
  //     this.state.rowsPaymentMode.map((row) => {
  //       row.dec_amount = "";
  //       row.vac_chequeno = "";
  //       row.vac_referenceno = "";
  //       row.dat_transactiondate = "";
  //       row.vac_remark = "";
  //     });
  //   }
  //   return result;
  // };
  // setSaveBtnDisplay = () => {
  //   let isParamFound =
  //     this.props.params &&
  //     this.props.params.EditPurchaseSrNo &&
  //     this.props.params.EditPurchaseSrNo.substring(1).length > 0;
  //   if (isParamFound !== true) {
  //     isParamFound = false;
  //   }
  //   let paramEditPurchaseSrNo = 0;
  //   if (isParamFound) {
  //     var editInfo = this.props.params.EditPurchaseSrNo.split(":");
  //     paramEditPurchaseSrNo = Number(editInfo[2]);
  //     if (paramEditPurchaseSrNo <= 0) {
  //       isParamFound = false;
  //     }
  //   }
  //   if (this.props.userPrivilege.Purchase == "M") {
  //     return "block";
  //   } else if (this.props.userPrivilege.Purchase == "R") {
  //     return "none";
  //   } else if (
  //     (this.props.userPrivilege.Purchase == "W" &&
  //       Number(this.state.formData.edit_salessrno) > Number(0) &&
  //       isParamFound === false) ||
  //     (this.props.userPrivilege.Purchase == "W" &&
  //       Number(this.state.formData.edit_salessrno) > Number(0) &&
  //       isParamFound === true &&
  //       Number(this.state.formData.edit_salessrno) !==
  //         Number(paramEditPurchaseSrNo)) ||
  //     (this.props.userPrivilege.Purchase == "W" &&
  //       Number(this.state.formData.edit_salessrno) <= Number(0))
  //   ) {
  //     return "block";
  //   } else {
  //     return "none";
  //   }
  // };
  // getDefaultEntrySettingRow = () => {
  //   let DefaultEntrySettingList = [];
  //   if (
  //     this.state.DefaultEntrySettingList &&
  //     this.state.DefaultEntrySettingList.length > 0
  //   ) {
  //     if (
  //       this.state.DefaultEntrySettingList[0].vac_transacationtype == "Paid"
  //     ) {
  //       DefaultEntrySettingList = this.state.DefaultEntrySettingList[0];
  //     } else {
  //       if (
  //         this.state.DefaultEntrySettingList[1].vac_transacationtype == "Paid"
  //       ) {
  //         DefaultEntrySettingList = this.state.DefaultEntrySettingList[1];
  //       }
  //     }
  //   }
  //   return DefaultEntrySettingList;
  // };
  // setPaymentData = (rowsPaymentMode) => {
  //   this.setState(
  //     {
  //       rowsPaymentMode,
  //     },
  //     () => {
  //       // console.log("this.state.rows", this.state.rows);
  //     }
  //   );
  // };
  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
    // this.togglePaymentModeInfo(); // Set anchor element to the clicked target
  };

  handleClose = () => {
    this.setState({ anchorEl: null }); // Close the menu
  };

  handleScroll = () => {
    if (window.scrollY > 200 && this.state.expanded) {
      this.setState({ expanded: false });
    } else if (window.scrollY < 200) {
      this.setState({ expanded: true });
    }
  };

  handleSelectTransactionType = () => {
    if (!(this.state.isEditMode && this.state.isInitialLoad)) {
      // Only open if NOT in edit mode
      this.openTransactionType();
      this.getPaymentModeDataStatus();
    }

    // if (type === " Advance") {
    //   this.getPaymentModeDataStatus();
    //   this.openTransactionType();
    // }
    // Update transaction type
  };

  openTransactionType = () => {
    let ARD = null;
    const { PaymentData, rowsPaymentMode } = this.state;
    let DefaultEntrySettingList = this.getDefaultEntrySettingRow();

    const txtAmount4PaymentModeTable =
      // Number(this.state.formData.txtAdvPayment) ||
      Number(this.state.formData.txtNetPayment);

    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={
            <PaymentModeTable
              DefaultEntrySettingList={DefaultEntrySettingList}
              PaymentData={PaymentData}
              PaymentLedgerNameList={rowsPaymentMode}
              Edit_SrNo={this.state.formData.edit_salessrno}
              setPaymentData={this.setPaymentData}
              txtAmount={txtAmount4PaymentModeTable}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
          handleOnClickNo={() => {
            this.setState({ ARD: null });
          }}
        />
      );
      this.setState({ ARD });
      // console.log("rowsPaymentMode:", this.state.rowsPaymentMode);
    });
  };
  getPaymentModeInfoAsText = () => {
    const { rowsPaymentMode } = this.state;

    if (rowsPaymentMode.length === 0) {
      return "No payment mode information available.";
    }

    return rowsPaymentMode
      .map((row, index) => {
        return `Payment Mode ${index + 1}: 
        Ledger Name: ${row.vac_ledgername || "N/A"}, 
        Amount: ${row.dec_amount || "0"}, 
        Cheque No: ${row.vac_chequeno || "N/A"}, 
        Reference No: ${row.vac_referenceno || "N/A"}, 
        Transaction Date: ${row.dat_transactiondate || "N/A"}, 
        Remark: ${row.vac_remark || "N/A"}`;
      })
      .join("\n");
  };
  refreshPaymentList = (rows, rowsCount) => {
    this.setState({
      rows,
      rowsCount,
    });
  };

  PaymenMode = () => {
    let ARD = null;
    const txtAdvPayment = this.state.formData.txtAdvPayment;
    const cmbCustomer = this.state.formData.cmbCustomer;

    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          // alertTitle={'Sales Item Entry'}
          alertMessage={
            <ReceiptEntry
              dtpFromDate={this.state.formData.dtpFromDate}
              dtpToDate={this.state.formData.dtpToDate}
              refreshPaymentList={this.refreshPaymentList}
              txtAdvPayment={txtAdvPayment}
              cmbCustomer={cmbCustomer}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  };

  eWayBillDataCall = () => {
    if (
      this.validateSales() &&
      this.validateSalesItemCount() &&
      this.validatePaymentModeAmount()
    ) {
      let openSalesEway = true,
        invalidUnitMsg = "";

      this.state.rows.forEach((row) => {
        const ValidUnit = this.state.ValidUnit.some(
          (unit) => unit.shortName.toUpperCase() === row.vac_unit.toUpperCase(),
        );
        if (!ValidUnit) {
          openSalesEway = false;
          invalidUnitMsg += `Sales Item S.N. ${row.bint_itemsrno} has an invalid packing unit: "${row.vac_unit}".</br>`;
        }
      });

      const handleOpenValidUnit = () => {
        this.setState({
          openValidUnitList: true,
        });
      };

      let ARDMsg = (
        <>
          <div>
            {/* <CtBtn
                label={"Valid E-way bill Unit List"}
                onClick={handleOpenValidUnit}
              /> */}
            <Button
              variant="outlined"
              startIcon={<Info />}
              onClick={handleOpenValidUnit}
            >
              Valid E-way bill Unit List
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              padding: "10px",
              backgroundColor: "#f9f9f9",
              borderLeft: "4px solid rgb(243, 33, 33)",
              borderRadius: "4px",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                color: "#333",
                lineHeight: "1.6",
              }}
              dangerouslySetInnerHTML={{ __html: invalidUnitMsg }}
            />
          </div>
        </>
      );

      if (openSalesEway == true) {
        if (
          this.state.formData.subSupplyType &&
          this.state.formData.subSupplyType !== null
        ) {
          this.setState({ ARD: null }, () => {
            let CustomerData = this.state.Customer.find(
              (row) => row.vac_customer === this.state.formData.cmbCustomer,
            );
            let HsnCode =
              this.state.rows.length > 0 && this.state.rows[0].vac_hsncode;
            // console.log("CustomerData", CustomerData);
            // console.log("HsnCode", HsnCode);
            console.log("this.state.CompanyList", this.state.CompanyList);

            let ARD = (
              <AlertResponsiveDialog
                alertMessage={
                  <SalesE_WayBill
                    EWayBillData={this.state.EWayBillData}
                    bint_acid={localStorage.getItem("acid")}
                    bint_acyear={localStorage.getItem("ACY")}
                    dat_salesdate={this.state.formData.dtpDate}
                    vac_billtype={this.state.formData.cmbBillType}
                    vac_billno={this.state.formData.LblBillNo}
                    dec_discamt={this.state.formData.txtDiscount}
                    dec_tdsamount={this.state.formData.txtTDSAmount}
                    dec_advancepayment={this.state.formData.txtAdvPayment}
                    vac_salestransactiontype={
                      this.state.formData.cmbTransactionType
                    }
                    dec_roundoff={this.state.formData.txtRoundOff}
                    dec_netpayment={this.state.formData.txtNetPayment}
                    bint_vouno={0}
                    vac_remark={this.state.formData.txtRemark}
                    vac_receiptgenerated={
                      this.state.formData.chkReceiptGenerated ? "Yes" : "No"
                    }
                    vac_referencename={this.state.formData.cmbReference}
                    dec_paidamt={0}
                    dec_remainamt={this.state.formData.dec_remainamt}
                    dec_beforetaxamt={this.state.totalBeforeTaxAmt}
                    dec_aftertaxamt={this.state.totalAfterTaxAmt}
                    bint_salessrno={this.state.formData.edit_salessrno}
                    SubSupplyType={this.state.formData.subSupplyType}
                    DocumentNo={this.state.formData.txtBillNo}
                    DocumentDate={this.state.formData.dtpDate}
                    Customer={this.state.formData.cmbCustomer}
                    ShipTo={this.state.formData.cmbShipTo}
                    Taxable={this.state.formData.txtTaxable}
                    totalAfterTaxAmt={this.state.totalAfterTaxAmt}
                    HsnCode={HsnCode}
                    CGST={this.state.formData.txtCGST}
                    SGST={this.state.formData.txtSGST}
                    IGST={this.state.formData.txtIGST}
                    GrandTotal={this.state.formData.txtGrandTotal}
                    CompanyDetails={this.state.CompanyList}
                    CustomerData={CustomerData}
                    PaymentData={this.state.PaymentData}
                    OtherDetailData={this.state.rowsOtherDetail}
                    setEwayBillARDNull={this.setEwayBillARDNull}
                    txtbasicamt={this.state.formData.txtbasicamt}
                    totalafterDeductionTaxamt={
                      this.state.totalafterDeductionTaxamt
                    }
                    totalAfteraddTaxamt={this.state.totalAfteraddTaxamt}
                    totalBeforeaddTaxamt={this.state.totalBeforeaddTaxamt}
                    totalBeforeDeductionTaxamt={
                      this.state.totalBeforeDeductionTaxamt
                    }
                  />
                }
                labelDisagree="Close"
                defaultOpenDialog={true}
                onYesClickCloseIfExeSuccessfully={true}
                maxWidthClass={"md"}
              />
            );

            this.setState({ ARD });
          });
        } else {
          this.props.toastErrorMsg(
            "Select Sub Supply Type In Setting->Invoice Setting",
          );
        }
      } else {
        this.setState({ ARD: null }, () => {
          let ARD = (
            <AlertResponsiveDialog
              alertTitle={"Invalid Packing Unit For E-Way Bill"}
              alertMessage={ARDMsg}
              labelDisagree="Ok"
              defaultOpenDialog={true}
              onYesClickCloseIfExeSuccessfully={true}
              maxWidthClass={"md"}
            />
          );

          this.setState({ ARD });
        });
      }
    }
  };

  //#endregion Function

  render() {
    // console.log("this.state.rowsOtherDetail", this.state.rowsOtherDetail);
    const { SupplierList, totals } = this.state;
    const isDisplaySaveBtn = this.setSaveBtnDisplay();
    let rowsTotal = getRowColSum(this.state.rows, [
      "dec_cgstamt",
      "dec_sgstamt",
      "dec_igstamt",
    ]);
    const rows = this.state.searchOpen
      ? this.state.searchRows
      : this.state.rows;
    // console.log("rows", rows);
    const rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;
    let CGST =
      Number(this.state.formData.txtCGST) != 0
        ? Number(this.state.formData.txtCGST)
        : Number(rowsTotal.dec_cgstamt) + Number(this.state.formData.tblCGST);
    let SGST =
      Number(this.state.formData.txtSGST) != 0
        ? Number(this.state.formData.txtSGST)
        : Number(rowsTotal.dec_sgstamt) + Number(this.state.formData.tblSGST);
    let IGST =
      Number(this.state.formData.txtIGST) != 0
        ? Number(this.state.formData.txtIGST)
        : Number(rowsTotal.dec_igstamt) + Number(this.state.formData.tblIGST);
    let txtsubtotal1 =
      Number(this.state.formData.txtTaxable) +
      Number(this.state.totalBeforeTaxAmt) +
      CGST +
      SGST +
      IGST +
      Number(this.state.totalAfterTaxAmt);
    let txtsubGrandtotal = txtsubtotal1.toFixed(2);
    let arrGrandTotal = getRoundOff(txtsubtotal1);

    let txtGrandTotal = arrGrandTotal["roff_number"].toFixed(2);
    let txtsubtotal =
      Number(this.state.formData.txtTaxable) +
      Number(this.state.totalBeforeTaxAmt);
    txtsubtotal = txtsubtotal.toFixed(2);

    let NetPayment =
      Number(txtsubtotal1) -
      Number(this.state.formData.txtTDSAmount) -
      Number(this.state.formData.txtAdvPayment);
    let arrNetPayment = getRoundOff(NetPayment);
    NetPayment = arrNetPayment["roff_number"].toFixed(2);
    let txtRoundOff = arrNetPayment["roff"].toFixed(2);

    let txtbasicamt = parseFloat(this.state.formData.txtbasicamt) || 0,
      txtDiscount = parseFloat(this.state.formData.txtDiscount) || 0,
      totalBeforeaddTaxamt = parseFloat(this.state.totalBeforeaddTaxamt) || 0,
      totalBeforeDeductionTaxamt =
        parseFloat(this.state.totalBeforeDeductionTaxamt) || 0,
      totalAfteraddTaxamt = parseFloat(this.state.totalAfteraddTaxamt) || 0,
      totalafterDeductionTaxamt =
        parseFloat(this.state.totalafterDeductionTaxamt) || 0,
      txtTaxable = parseFloat(this.state.formData.txtTaxable) || 0;

    return (
      <form>
        <Grid container direction="row" gap={2}>
          {/* <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "30px", color: "#515151" }}
            >
              <b>Sales Entry</b>
            </label>
          </Grid> */}
          <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="flex-start"
            spacing={2}
            marginTop={1.5}
          >
            <Grid item sm={12} lg={6}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                marginTop={0}
              >
                <Grid item>
                  <CtDtp
                    id="dtpDate"
                    label="Date*"
                    width="150"
                    handleOnChange={this.handleOnChange}
                    defaultValue={this.state.formData.dtpDate}
                    value={this.state.formData.dtpDate}
                    onKeyDown={this.props.onKeyDown}
                    accountYear={localStorage.getItem("ACY")}
                    nextCtrlID={"cmbBillType"}
                  />
                </Grid>
                <Grid item>
                  <CtCmb
                    id="cmbBillType"
                    label="Bill Type*"
                    value={this.state.formData.cmbBillType}
                    handleOnChange={this.handleOnChange}
                    items={this.state.BillNoList}
                    width={120}
                    maxLength={20}
                    colID="vac_invoicetype"
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>
                <Grid
                  item
                  display={
                    this.state.SalesInvoiceGeneration == "Manually"
                      ? "block"
                      : "none"
                  }
                >
                  <CtTxtNum
                    id="txtBillNo"
                    label="Bill No*"
                    // disabled={true}
                    value={this.state.formData.txtBillNo}
                    handleOnChange={this.handleOnChange}
                    width={80}
                    maxLength={10}
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>
                <Grid
                  item
                  display={
                    this.state.SalesInvoiceGeneration == "Manually"
                      ? "block"
                      : "none"
                  }
                >
                  <CtBtn
                    label={<RefreshOutlined />}
                    onClick={this.generateBillNo}
                  />
                </Grid>
                <Grid item>
                  <label>{this.state.formData.LblBillNo}</label>
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                marginTop={0}
              >
                <Grid item>
                  <CtCmbEditable
                    id="cmbCustomer"
                    label="Customer*"
                    items={this.state.Customer}
                    value={this.state.formData.cmbCustomer}
                    handleOnChange={this.handleOnChange}
                    width={250}
                    maxLength={100}
                    colID="vac_customer"
                    bolVisibleOnAddClickIcon={
                      this.props.userPrivilege.Customer == "A" ? true : false
                    }
                    onAddClick={this.onAddClickCustomer}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID="cmbShipTo"
                  />
                </Grid>
                <Grid
                  item
                  display={this.state.Displaybtn === true ? "block" : "none"}
                >
                  <CtBtn
                    label="Order Selection"
                    onClick={this.OrderSelection}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                marginTop={0}
              >
                <Grid item>
                  <CtCmbEditable
                    id="cmbShipTo"
                    label="Ship To"
                    items={this.state.ShipTo}
                    value={this.state.formData.cmbShipTo}
                    handleOnChange={this.handleOnChange}
                    width={250}
                    maxLength={100}
                    colID="vac_customer"
                    bolVisibleOnAddClickIcon={
                      this.props.userPrivilege.Customer == "A" ? true : false
                    }
                    onAddClick={this.onAddClickCustomer}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID="cmbReference"
                  />
                </Grid>
                <Grid item>
                  <CtCmbEditable
                    id="cmbReference"
                    label="Reference"
                    items={this.state.ReferenceList}
                    value={this.state.formData.cmbReference}
                    handleOnChange={this.handleOnChange}
                    width={250}
                    maxLength={100}
                    colID="vac_referencename"
                    bolVisibleOnAddClickIcon={
                      this.props.userPrivilege.Reference &&
                      this.props.userPrivilege.Reference == "A"
                        ? true
                        : false
                    }
                    onAddClick={this.onAddClickReference}
                    onKeyDown={this.props.onKeyDown}
                    defaultAction={this.saveSales}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={12} lg={6}>
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={2}
                marginTop={0}
              >
                <Grid item>
                  {this.state.formData.cmbCustomer.length > 0 ? (
                    <TableList
                      columns={this.state.columnsOtherDetail}
                      counter={this.state.counter}
                      rows={this.state.rowsOtherDetail.filter(
                        (row) => row.vac_calculation === "",
                      )}
                      rowsCount={this.state.rowsCountOtherDetail}
                      rowsPerPage={this.state.rowsPerPageOtherDetail}
                      handleChangeRowsPerPage={
                        this.handleChangeRowsPerPageOtherDetail
                      }
                      handleOnRowDataChange={
                        this.handleOnRowDataChangeOtherDetail
                      }
                    />
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item display={isDisplaySaveBtn}>
          <div
            style={{
              position: "fixed",
              top: "100px",
              right: "20px",
              zIndex: 1000,
              display: "flex",
              gap: "10px", // space between buttons
              backgroundColor: "white",
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                this.props.navigateTo("SalesList");
              }}
            >
              Sales List
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.saveSales()}
            >
              Save
            </Button>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  this.trimFormData(() => {
                    this.saveSales(true);
                  });
                }}
              >
                Print Invoice
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleInvoice}
              >
                E-Invoice
              </Button>
            </Grid>
          </div>
        </Grid> */}

        <Grid item>
          <Slide in={true} direction="left">
            <div
              style={{
                position: "fixed",
                top: "70px",
                right: "1px",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                backgroundColor: "white",
                borderRadius: "8px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                padding: "8px",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <Tooltip
                title={this.state.expanded ? "Hide Actions" : "Show Actions"}
                arrow
                display={isDisplaySaveBtn}
              >
                <Button onClick={this.handleToggle}>
                  {this.state.expanded ? <ArrowForwardIos /> : <ArrowBackIos />}
                </Button>
              </Tooltip>

              <Collapse in={!this.state.expanded} orientation="horizontal">
                <Box sx={{ display: "flex", gap: 1, ml: 1 }}>
                  <Tooltip title="Save">
                    <IconButton
                      onClick={() => {
                        this.trimFormData(() => {
                          this.saveSales(false);
                        });
                      }}
                    >
                      <Save sx={{ color: "#3487d7" }} />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Print Invoice">
                    <IconButton
                      onClick={() => {
                        this.trimFormData(() => {
                          this.saveSales(true);
                        });
                      }}
                    >
                      <Print sx={{ color: "#3487d7" }} />
                    </IconButton>
                  </Tooltip>
                  {localStorage.getItem("int_einvoice") == 1 && (
                    <Tooltip title="E-Invoice">
                      <IconButton onClick={this.handleInvoice}>
                        <InsertDriveFile sx={{ color: "#3487d7" }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  {localStorage.getItem("int_ewaybill") == 1 && (
                    <Tooltip title="E-Way Bill Data">
                      <IconButton onClick={this.eWayBillDataCall}>
                        <Print sx={{ color: "#3487d7" }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title="Sales List">
                    <IconButton
                      onClick={() => {
                        this.props.navigateTo("SalesList");
                      }}
                    >
                      <ViewList />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="New">
                    <IconButton onClick={this.clearInfo}>
                      <img
                        src={New_Blue}
                        alt="New"
                        style={{
                          width: 28,
                          height: 28,
                          objectFit: "contain",
                          filter: "grayscale(100%) brightness(0.6)", // make blue → gray
                          opacity: 0.8,
                        }}
                      />
                    </IconButton>
                  </Tooltip>

                  {this.props.userPrivilege.Sales === "M" && (
                    <Tooltip title="Delete">
                      <IconButton
                        onClick={this.onDeleteBtnClick}
                        disabled={
                          this.state.formData.edit_salessrno > 0 ? false : true
                        }
                      >
                        <Delete sx={{ color: "#fe6969" }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              </Collapse>

              <Collapse in={this.state.expanded} orientation="horizontal">
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "center",
                    marginLeft: 1,
                  }}
                >
                  <Grid item display={isDisplaySaveBtn}>
                    <CtBtn
                      label="Save"
                      onClick={() => {
                        this.trimFormData(() => {
                          this.saveSales(false);
                        });
                      }}
                    />
                  </Grid>
                  <Grid item display={isDisplaySaveBtn}>
                    <CtBtn
                      label="Print Invoice"
                      iconName={"print"}
                      onClick={() => {
                        this.trimFormData(() => {
                          this.saveSales(true);
                        });
                      }}
                    />
                  </Grid>
                  {localStorage.getItem("int_einvoice") == 1 && (
                    <Grid item display={isDisplaySaveBtn}>
                      <CtBtn
                        label="E-Invoice"
                        onClick={this.handleInvoice}
                        iconName={"invoice"}
                      />
                    </Grid>
                  )}
                  {localStorage.getItem("int_ewaybill") == 1 && (
                    <Grid item display={isDisplaySaveBtn}>
                      <CtBtn
                        label="E-Way Bill Data"
                        iconName={"print"}
                        onClick={this.eWayBillDataCall}
                      />
                    </Grid>
                  )}
                  <Grid item>
                    <CtBtn
                      label="Sales List"
                      iconName={"List"}
                      variant="outlined"
                      onClick={() => {
                        this.props.navigateTo("SalesList");
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <CtBtn
                      variant="outlined"
                      label="New"
                      onClick={this.clearInfo}
                    />
                  </Grid>
                  <Grid
                    item
                    display={
                      this.props.userPrivilege.Sales !== "M" ? "none" : "block"
                    }
                  >
                    <CtBtn
                      className="Delete"
                      label="Delete"
                      onClick={this.onDeleteBtnClick}
                      disabled={
                        this.state.formData.edit_salessrno > 0 ? false : true
                      }
                    />
                  </Grid>
                </Box>
              </Collapse>
            </div>
          </Slide>
        </Grid>

        <Grid item marginTop={3} className="maintable">
          {/* <TableContainer component={Paper}>
            <TableList
              columns={this.state.columns}
              counter={this.state.counter}
              rows={rows}
              rowsCount={rowsCount}
              rowsPerPage={this.state.rowsPerPage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              handleOnActionClick={this.handleARDonActionClick}
              actionList={this.state.actionList}
              keyColumn={this.state.keyColumn}
              handleOnSearchChange={this.handleOnSearchChange}
              searchColumns={this.state.searchColumns}
              searchData={this.state.searchData}
              provideSearch={true}
              handleOnNewEntryClick={() => {
                this.trimFormData(this.handleOnNewEntryClick);
              }}
            />
          </TableContainer> */}
          <CtART
            rowsdata={rows}
            columnsdata={this.state.columns}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("SalesEntry")}
            rowIconAction={[
              {
                label: "Edit",
                onClick: this.handleARDonActionClick_Edit,
                icon: "Edit",
                className: "secondary-button",
              },
              {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              },
            ]}
            tableButtonAction={[
              {
                label: "Sales Item Entry",
                onClick: this.handleOnNewEntryClick,
                addPluseIcon: true,
              },
            ]}
            showColumnFilters={false}
            hideColIdList={["bint_salessrno"]}
            actionColSize={50}
            density={"compact"}
          />
        </Grid>
        <FormControl fullWidth>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            marginTop={2}
          >
            {/* <h4
                variant="h6"
                style={{
                  color: "blue",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={this.handleClick}
              >
                <span
                  style={{ fontSize: "25px", color: "blue", cursor: "pointer" }}
                >
                  →
                </span>
                Transaction Type : {this.state.formData.cmbTransactionType}
              </h4>
              <Menu
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl)}
                onClose={this.handleClose}
              >
                <MenuItem
                  onClick={() => this.handleSelectTransactionType("Paid")}
                >
                  {" "}
                  Paid
                </MenuItem>

                <MenuItem
                  onClick={() => this.handleSelectTransactionType("Remain")}
                >
                  {" "}
                  Remain
                </MenuItem>
              </Menu> */}

            <Box
              display="flex"
              flexDirection="row"
              alignItems="flex-start"
              marginTop={2}
              gap={2}
            >
              <h4
                variant="h6"
                style={{
                  color: "blue",
                  cursor: "pointer",
                }}
              >
                Transaction Type :
              </h4>

              <Grid item>
                <CtCmb
                  id="cmbTransactionType"
                  label=""
                  items={this.state.Type}
                  value={this.state.formData.cmbTransactionType}
                  handleOnChange={this.handleOnChange}
                  width={85}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtWayBridgeCharge"
                  disabled={
                    this.state.ispaid === true &&
                    this.state.formData.cmbTransactionType === "Paid"
                  }
                />
              </Grid>
              {this.state.formData.cmbTransactionType === "Paid" &&
                this.state.ispaid !== true && (
                  <img
                    src={PaymentModeIcon}
                    alt="Payment Mode"
                    style={{
                      marginTop: "14px",
                      paddingLeft: "8px",
                      paddingRight: "8px",
                      cursor: "pointer",
                      width: "34px", // Adjust as needed
                      height: "34px",
                    }}
                    onClick={this.openTransactionType}
                  />
                )}
            </Box>

            {/* {this.state.formData.cmbTransactionType === "Paid" ? ( */}
            <Box>
              {this.state.rowsPaymentMode.map((row, index) => {
                if (
                  this.state.formData.cmbTransactionType !== "Paid" ||
                  !row.dec_amount
                ) {
                  return null;
                }

                const backgroundprocess = row.vac_backgroundprocess;
                if (!["Cash", "Cheque", "Bank"].includes(backgroundprocess)) {
                  return null;
                }

                return (
                  <Box key={`payment-${index}`}>
                    <h4 style={{ margin: 5 }}>
                      Payment Mode: {row.vac_ledgername}
                    </h4>
                    <h4 style={{ margin: 5 }}>Amount: {row.dec_amount}</h4>
                    <h4 style={{ margin: 5 }}>Cheque No: {row.vac_chequeno}</h4>
                    <h4 style={{ margin: 5 }}>
                      Reference No: {row.vac_referenceno}
                    </h4>
                    <h4 style={{ margin: 5 }}>
                      Transaction Date:{" "}
                      {row.dat_transactiondate
                        ? moment(row.dat_transactiondate).format("DD-MM-YYYY")
                        : ""}
                    </h4>
                    <h4 style={{ margin: 5 }}>Remark: {row.vac_remark}</h4>
                    <hr />
                  </Box>
                );
              })}
            </Box>
            {/* ) : null} */}
          </Box>{" "}
          <Box display="flex" justifyContent="space-between" marginTop={2}>
            <Box flex={2}>
              <Grid item sm={12} lg={6}>
                <Grid
                  container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={2}
                  marginTop={0}
                >
                  <Grid item>
                    {this.state.formData.cmbCustomer.length > 0 ? (
                      <TableList
                        columns={this.state.columnsOtherDetail}
                        counter={this.state.counter}
                        rows={this.state.rowsOtherDetail1.filter(
                          (row) => row.vac_calculation !== "",
                        )}
                        rowsCount={this.state.rowsCountOtherDetail1}
                        rowsPerPage={this.state.rowsPerPageOtherDetail1}
                        handleChangeRowsPerPage={
                          this.handleChangeRowsPerPageOtherDetail1
                        }
                        handleOnRowDataChange={
                          this.handleOnRowDataChangeOtherDetail1
                        }
                      />
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-end"
              position="sticky"
              top={0}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginBottom: 10,
                }}
              >
                <tbody>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Amount:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtbasicamt.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Item Discount:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtDiscount.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Other Deduction (BT):
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {totalBeforeDeductionTaxamt.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Other Charges (BT):
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {totalBeforeaddTaxamt.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Taxable:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtTaxable.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Sub Total:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtsubtotal}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total CGST:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {CGST.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total SGST:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {SGST.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total IGST:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {IGST.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Other Deduction (AT):
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {totalafterDeductionTaxamt.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Other Charges (AT):
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {totalAfteraddTaxamt.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Sub Total:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtsubGrandtotal}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      RoundOff:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtRoundOff}
                    </td>
                  </tr>
                  <tr style={{ borderTop: "1px solid #000" }}>
                    <td
                      style={{
                        textAlign: "left",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      Grand Total:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtGrandTotal}
                    </td>
                  </tr>
                </tbody>
              </table>

              <CtTxt
                id="txtTDSAmount"
                label="TDS Amount"
                handleOnChange={this.handleOnChange}
                value={this.state.formData.txtTDSAmount}
                width={110}
                maxLength={10}
                textAlign="right"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID="txtAdvPayment"
              />

              <Box
                display="flex"
                justifyContent="flex-end"
                gap={3}
                style={{ marginTop: 10 }}
              >
                {this.state.formData.cmbCustomer &&
                  this.state.formData.txtAdvPayment > 0 && (
                    <CtBtn label="Generate Receipt" onClick={this.PaymenMode} />
                  )}

                <CtTxtAmt
                  id="txtAdvPayment"
                  label="Adv Payment"
                  value={this.state.formData.txtAdvPayment}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  textAlign="right"
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                />
              </Box>

              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginTop: 10,
                }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        textAlign: "left",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      Net Payment:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {NetPayment}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>
          </Box>
        </FormControl>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(SalesEntry))));
